import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  JSONObject: any;
  UUID: any;
  Upload: any;
};

export type ActiveTimeSlotInput = {
  employeeId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};

export type AddEmployeeInput = {
  description?: InputMaybe<Scalars['String']>;
  email?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
};

export type AddServiceInput = {
  amount?: InputMaybe<Scalars['Float']>;
  description?: InputMaybe<Scalars['String']>;
  duration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
};

export type AddTagInput = {
  name: Scalars['String'];
  organizationId: Scalars['UUID'];
};

export type AdminCreateServiceReservationInput = {
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['UUID'];
  endAt: Scalars['String'];
  firstName?: InputMaybe<Scalars['String']>;
  isGdprConfirmed?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  serviceAmount?: InputMaybe<Scalars['Float']>;
  startAt: Scalars['String'];
};

export type Appointment = {
  __typename?: 'Appointment';
  appointmentsCountBefore: Scalars['Int'];
  createdAtUtc: Datetime;
  date: Scalars['String'];
  description: Scalars['String'];
  email: Scalars['String'];
  employee: Employee;
  endedAtUtc?: Maybe<Datetime>;
  firstName: Scalars['String'];
  hasStarted?: Maybe<Scalars['Boolean']>;
  id: Scalars['UUID'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  position: Scalars['Int'];
  reason: Scalars['String'];
  startedAtUtc?: Maybe<Datetime>;
  status: AppointmentStatus;
  updatedAtUtc?: Maybe<Datetime>;
};

export type AppointmentInput = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export enum AppointmentStatus {
  Active = 'active',
  Cancelled = 'cancelled',
  Done = 'done'
}

export type AppointmentsFilterInput = {
  date?: InputMaybe<RangeDateInput>;
  status?: InputMaybe<AppointmentStatus>;
};

export type AppointmentsInput = {
  filter?: InputMaybe<AppointmentsFilterInput>;
};

export type Attachment = {
  __typename?: 'Attachment';
  id: Scalars['UUID'];
  name: Scalars['String'];
  publicUrl: Scalars['String'];
};

export type CancelEmployeeReservationInput = {
  email: Scalars['String'];
  id: Scalars['UUID'];
};

export type CancelReservationInput = {
  email: Scalars['String'];
  id: Scalars['UUID'];
};

export type CancelServiceReservationInput = {
  email: Scalars['String'];
  id: Scalars['UUID'];
};

export type ChangeTimeSlotEntityMaxLimitInput = {
  changeAllFollowing?: InputMaybe<Scalars['Boolean']>;
  employeeId: Scalars['UUID'];
  entityLimitMax: Scalars['Int'];
  organizationId: Scalars['UUID'];
  timeSlotId: Scalars['UUID'];
};

export type ChangeTimeSlotInput = {
  employeeId: Scalars['UUID'];
  endAtUtc: Scalars['String'];
  organizationId: Scalars['UUID'];
  startAtUtc: Scalars['String'];
  timeSlotId: Scalars['UUID'];
};

export type CreateAppointmentInput = {
  date: Scalars['String'];
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['UUID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  reason: Scalars['String'];
  recaptchaToken: Scalars['String'];
};

export type CreateAppointmentPersonalInput = {
  employeeId: Scalars['UUID'];
};

export type CreateEmployeeReservationInput = {
  description: Scalars['String'];
  email: Scalars['String'];
  employeeId: Scalars['UUID'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  reason: Scalars['String'];
  timeSlotId: Scalars['UUID'];
};

export type CreateOrganizationInput = {
  city: Scalars['String'];
  countryIsoCode: Scalars['String'];
  email: Scalars['String'];
  ico: Scalars['String'];
  name: Scalars['String'];
  organizationApplicationId: Scalars['UUID'];
  street: Scalars['String'];
  zipCode: Scalars['String'];
};

export type CreateReservationInput = {
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['UUID'];
  firstName?: InputMaybe<Scalars['String']>;
  isGdprConfirmed?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  recaptchaToken: Scalars['String'];
  timeSlotId: Scalars['UUID'];
};

export type CreateServiceReservationInput = {
  customerLanguage?: InputMaybe<Scalars['String']>;
  description?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  employeeId: Scalars['UUID'];
  firstName?: InputMaybe<Scalars['String']>;
  isGdprConfirmed?: InputMaybe<Scalars['Boolean']>;
  lastName?: InputMaybe<Scalars['String']>;
  phoneNumber?: InputMaybe<Scalars['String']>;
  reason?: InputMaybe<Scalars['String']>;
  serviceId: Scalars['UUID'];
  timeSlotIds: Array<Scalars['UUID']>;
};

export type CreateTimeSlotInput = {
  employeeId: Scalars['UUID'];
  endAtUtc: Scalars['String'];
  entityLimitMax?: InputMaybe<Scalars['Int']>;
  isGroupCreate: Scalars['Boolean'];
  isRepeatable: Scalars['Boolean'];
  organizationId: Scalars['UUID'];
  startAtUtc: Scalars['String'];
  step?: InputMaybe<Scalars['Int']>;
  title: Scalars['String'];
  type: Scalars['String'];
};

export type Customer = {
  __typename?: 'Customer';
  email: Scalars['String'];
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
};

export type CustomerNoShowHistoryInput = {
  email: Scalars['String'];
  organizationId: Scalars['UUID'];
};

export type DashboardKpIs = {
  __typename?: 'DashboardKPIs';
  activeCustomers: Scalars['Int'];
  bookingsChange?: Maybe<Scalars['Float']>;
  cancellationRate: Scalars['Float'];
  cancellationRateChange?: Maybe<Scalars['Float']>;
  customersChange?: Maybe<Scalars['Float']>;
  revenueChange?: Maybe<Scalars['Float']>;
  totalBookings: Scalars['Int'];
  totalRevenue: Scalars['Float'];
};

export type DashboardStats = {
  __typename?: 'DashboardStats';
  kpis: DashboardKpIs;
  monthlyOccupancy: MonthlyOccupancyHeatmap;
  topLists: DashboardTopLists;
  trends: DashboardTrends;
};

export type DashboardStatsInput = {
  endDate: Scalars['String'];
  organizationId: Scalars['UUID'];
  selectedEmployeeId?: InputMaybe<Scalars['UUID']>;
  startDate: Scalars['String'];
};

export type DashboardTopLists = {
  __typename?: 'DashboardTopLists';
  topEmployees: Array<TopEmployee>;
  topServices: Array<TopService>;
};

export type DashboardTrends = {
  __typename?: 'DashboardTrends';
  bookingsTrend: Array<TrendDataPoint>;
  revenueTrend: Array<TrendDataPoint>;
};

export type Datetime = {
  __typename?: 'Datetime';
  isoFormat: Scalars['String'];
  utcFormat: Scalars['String'];
};

export type DayOccupancy = {
  __typename?: 'DayOccupancy';
  availableHours: Scalars['Float'];
  date: Scalars['String'];
  occupancyRate: Scalars['Float'];
  occupiedHours: Scalars['Float'];
};

export type DeleteAppointmentInput = {
  email: Scalars['String'];
  id: Scalars['UUID'];
};

export type DeleteEmployeeInput = {
  id: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};

export type DeleteServiceInput = {
  id: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};

export type DeleteTagInput = {
  id: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};

export type DeleteTimeSlotInput = {
  employeeId: Scalars['UUID'];
  isWithDeleteAllFollowing?: InputMaybe<Scalars['Boolean']>;
  organizationId: Scalars['UUID'];
  timeSlotId: Scalars['UUID'];
};

export type Employee = {
  __typename?: 'Employee';
  appointments: Array<Appointment>;
  appointmentsCount: Scalars['Int'];
  areSlotsBookable: Array<SlotBookability>;
  averageAppointmentTimeInSeconds?: Maybe<Scalars['Int']>;
  bookableSlots: Array<TimeSlot>;
  createdAtUtc: Datetime;
  currentAppointment?: Maybe<Appointment>;
  currentAppointmentPosition?: Maybe<Scalars['Int']>;
  description?: Maybe<Scalars['String']>;
  descriptionTranslations?: Maybe<Scalars['JSONObject']>;
  email?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isAllowedToCreateNewAppointment: Scalars['Boolean'];
  isAllowedToCreateNewAppointmentDayOff: Scalars['Boolean'];
  isAllowedToCreateNewAppointmentDaysBeforeLimitation: Scalars['Boolean'];
  isAllowedToCreateNewAppointmentFull: Scalars['Boolean'];
  isAllowedToCreateNewAppointmentWorkingHours: Scalars['Boolean'];
  isReceivingReservationCreatedEmails: Scalars['Boolean'];
  name?: Maybe<Scalars['String']>;
  nameTranslations?: Maybe<Scalars['JSONObject']>;
  nextAppointment?: Maybe<Appointment>;
  nextAppointmentPosition?: Maybe<Scalars['Int']>;
  note?: Maybe<Scalars['String']>;
  organization: Organization;
  phoneNumber?: Maybe<Scalars['String']>;
  position: Scalars['Int'];
  profilePictureAttachment?: Maybe<Attachment>;
  queueSlot?: Maybe<TimeSlot>;
  serviceSlots: Array<TimeSlot>;
  services: Array<Service>;
  status: Scalars['String'];
  tags: Array<Tag>;
  translatedDescription?: Maybe<Scalars['String']>;
  translatedName?: Maybe<Scalars['String']>;
  updatedAtUtc?: Maybe<Datetime>;
};


export type EmployeeAppointmentsArgs = {
  input: EmployeeAppointmentsInput;
};


export type EmployeeAppointmentsCountArgs = {
  input: EmployeeAppointmentsInput;
};


export type EmployeeAreSlotsBookableArgs = {
  input: HasBookableSlotInput;
};


export type EmployeeBookableSlotsArgs = {
  date?: InputMaybe<Scalars['String']>;
};


export type EmployeeCurrentAppointmentArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type EmployeeCurrentAppointmentPositionArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type EmployeeIsAllowedToCreateNewAppointmentArgs = {
  input?: InputMaybe<EmployeeIsAllowedToCreateNewAppointmentInput>;
};


export type EmployeeIsAllowedToCreateNewAppointmentDayOffArgs = {
  input?: InputMaybe<EmployeeIsAllowedToCreateNewAppointmentInput>;
};


export type EmployeeIsAllowedToCreateNewAppointmentDaysBeforeLimitationArgs = {
  input?: InputMaybe<EmployeeIsAllowedToCreateNewAppointmentInput>;
};


export type EmployeeIsAllowedToCreateNewAppointmentFullArgs = {
  input?: InputMaybe<EmployeeIsAllowedToCreateNewAppointmentInput>;
};


export type EmployeeIsAllowedToCreateNewAppointmentWorkingHoursArgs = {
  input?: InputMaybe<EmployeeIsAllowedToCreateNewAppointmentInput>;
};


export type EmployeeNextAppointmentArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type EmployeeNextAppointmentPositionArgs = {
  input?: InputMaybe<Scalars['String']>;
};


export type EmployeeQueueSlotArgs = {
  date: Scalars['String'];
};


export type EmployeeServiceSlotsArgs = {
  date: Scalars['String'];
};


export type EmployeeTranslatedDescriptionArgs = {
  lang?: InputMaybe<Scalars['String']>;
};


export type EmployeeTranslatedNameArgs = {
  lang?: InputMaybe<Scalars['String']>;
};

export type EmployeeAppointmentsInput = {
  date: Scalars['String'];
  status?: InputMaybe<Scalars['String']>;
  view?: InputMaybe<Scalars['String']>;
};

export type EmployeeIsAllowedToCreateNewAppointmentInput = {
  date?: InputMaybe<Scalars['String']>;
};

export type EmployeeReservation = {
  __typename?: 'EmployeeReservation';
  createdAtUtc: Datetime;
  date: Scalars['String'];
  description: Scalars['String'];
  email: Scalars['String'];
  employee: Employee;
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  reason: Scalars['String'];
  status: EmployeeReservationStatus;
  timeSlot: TimeSlot;
  updatedAtUtc?: Maybe<Datetime>;
};

export type EmployeeReservationInput = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export enum EmployeeReservationStatus {
  Active = 'active',
  CancelledByEmployee = 'cancelled_by_employee',
  CancelledByPatient = 'cancelled_by_patient',
  Done = 'done'
}

export type Employees = {
  __typename?: 'Employees';
  data: Array<Employee>;
  paginationInfo: PaginationInfo;
};

export type EmployeesFilterInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type EmployeesInput = {
  filter?: InputMaybe<EmployeesFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type FreeServiceReservationTimeSlotsInput = {
  employeeId: Scalars['UUID'];
  endAtUtc: Scalars['String'];
  startAtUtc: Scalars['String'];
};

export type HasBookableSlotInput = {
  from: Scalars['String'];
  to: Scalars['String'];
};

export type MarkNoShowInput = {
  id: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};

export type MonthlyOccupancyHeatmap = {
  __typename?: 'MonthlyOccupancyHeatmap';
  days: Array<DayOccupancy>;
};

export type Mutation = {
  __typename?: 'Mutation';
  addEmployee: Organization;
  addService: Organization;
  addTag: Organization;
  adminCreateServiceReservation: ServiceReservation;
  cancelEmployeeReservation: EmployeeReservation;
  cancelReservation: Reservation;
  cancelServiceReservation: ServiceReservation;
  changeTimeSlot: TimeSlot;
  changeTimeSlotEntityLimitMax: TimeSlot;
  createEmployeeReservation: EmployeeReservation;
  createOrganization: Organization;
  createReservation: SimplifiedReservation;
  createServiceReservation: ServiceReservation;
  createTimeSlot?: Maybe<TimeSlot>;
  deleteEmployee: Organization;
  deleteService: Organization;
  deleteTag: Organization;
  deleteTimeSlot?: Maybe<Scalars['Boolean']>;
  markServiceReservationNoShow: ServiceReservation;
  onboardOrganization: Organization;
  reorderEmployees: Organization;
  resetPassword?: Maybe<Scalars['Boolean']>;
  sendResetPasswordEmail?: Maybe<Scalars['Boolean']>;
  signInAsOrganization: SignInAsOrganizationResponse;
  unmarkServiceReservationNoShow: ServiceReservation;
  updateEmployee: Employee;
  updateOrganization: Organization;
  updateService: Organization;
  updateTag: Organization;
};


export type MutationAddEmployeeArgs = {
  input: AddEmployeeInput;
};


export type MutationAddServiceArgs = {
  input: AddServiceInput;
};


export type MutationAddTagArgs = {
  input: AddTagInput;
};


export type MutationAdminCreateServiceReservationArgs = {
  input: AdminCreateServiceReservationInput;
};


export type MutationCancelEmployeeReservationArgs = {
  input: CancelEmployeeReservationInput;
};


export type MutationCancelReservationArgs = {
  input: CancelReservationInput;
};


export type MutationCancelServiceReservationArgs = {
  input: CancelServiceReservationInput;
};


export type MutationChangeTimeSlotArgs = {
  input: ChangeTimeSlotInput;
};


export type MutationChangeTimeSlotEntityLimitMaxArgs = {
  input: ChangeTimeSlotEntityMaxLimitInput;
};


export type MutationCreateEmployeeReservationArgs = {
  input: CreateEmployeeReservationInput;
};


export type MutationCreateOrganizationArgs = {
  input: CreateOrganizationInput;
};


export type MutationCreateReservationArgs = {
  input: CreateReservationInput;
};


export type MutationCreateServiceReservationArgs = {
  input: CreateServiceReservationInput;
};


export type MutationCreateTimeSlotArgs = {
  input: CreateTimeSlotInput;
};


export type MutationDeleteEmployeeArgs = {
  input: DeleteEmployeeInput;
};


export type MutationDeleteServiceArgs = {
  input: DeleteServiceInput;
};


export type MutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type MutationDeleteTimeSlotArgs = {
  input: DeleteTimeSlotInput;
};


export type MutationMarkServiceReservationNoShowArgs = {
  input: MarkNoShowInput;
};


export type MutationOnboardOrganizationArgs = {
  input: OnboardOrganizationInput;
};


export type MutationReorderEmployeesArgs = {
  input: ReorderEmployeesInput;
};


export type MutationResetPasswordArgs = {
  input: ResetPasswordInput;
};


export type MutationSendResetPasswordEmailArgs = {
  email: Scalars['String'];
  recaptchaToken: Scalars['String'];
};


export type MutationSignInAsOrganizationArgs = {
  input: SignInAsOrganizationInput;
};


export type MutationUnmarkServiceReservationNoShowArgs = {
  input: UnmarkNoShowInput;
};


export type MutationUpdateEmployeeArgs = {
  input: UpdateEmployeeInput;
};


export type MutationUpdateOrganizationArgs = {
  input: UpdateOrganizationInput;
};


export type MutationUpdateServiceArgs = {
  input: UpdateServiceInput;
};


export type MutationUpdateTagArgs = {
  input: UpdateTagInput;
};

export type NextAppointmentInput = {
  employeeId: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};

export type NoShowEntry = {
  __typename?: 'NoShowEntry';
  date: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  lastName?: Maybe<Scalars['String']>;
  localStartTime?: Maybe<Scalars['String']>;
  markedBy: Scalars['String'];
  noShowAtUtc: Scalars['String'];
  noShowType: NoShowType;
  phoneNumber?: Maybe<Scalars['String']>;
  reservationId: Scalars['UUID'];
  serviceAmount?: Maybe<Scalars['Float']>;
  serviceName?: Maybe<Scalars['String']>;
  startAtUtc?: Maybe<Scalars['String']>;
};

export type NoShowHistory = {
  __typename?: 'NoShowHistory';
  count: Scalars['Int'];
  lateCancellationCount: Scalars['Int'];
  noShowCount: Scalars['Int'];
  windowMonths: Scalars['Int'];
};

export type NoShowListInput = {
  fromDate?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  toDate?: InputMaybe<Scalars['String']>;
};

export enum NoShowType {
  LateCancellation = 'late_cancellation',
  NoShow = 'no_show'
}

export type OnboardOrganizationInput = {
  email: Scalars['String'];
  onboardingToken: Scalars['String'];
  password: Scalars['String'];
};

export type Organization = {
  __typename?: 'Organization';
  activeExtraPackages: Array<Scalars['String']>;
  city: Scalars['String'];
  countryIsoCode: Scalars['String'];
  createdAtUtc: Datetime;
  daysInFutureAllowedToBook: Scalars['Int'];
  defaultLanguage: Scalars['String'];
  email?: Maybe<Scalars['String']>;
  employees: Array<Employee>;
  ico?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  isOfferingAnyBookable: Scalars['Boolean'];
  isOfferingAnyQueue: Scalars['Boolean'];
  managementEmployees: Array<Employee>;
  name: Scalars['String'];
  note?: Maybe<Scalars['String']>;
  profilePictureAttachment?: Maybe<Attachment>;
  services: Array<Service>;
  slug: Scalars['String'];
  state?: Maybe<Scalars['String']>;
  status: Scalars['String'];
  street: Scalars['String'];
  supportedLanguages: Array<Scalars['String']>;
  updatedAtUtc?: Maybe<Datetime>;
  zipCode: Scalars['String'];
};


export type OrganizationEmployeesArgs = {
  input?: InputMaybe<OrganizationEmployeesInput>;
};


export type OrganizationManagementEmployeesArgs = {
  input?: InputMaybe<OrganizationEmployeesInput>;
};

export type OrganizationEmployeesInput = {
  status?: InputMaybe<Array<Scalars['String']>>;
};

export type OrganizationExtraPackage = {
  __typename?: 'OrganizationExtraPackage';
  id: Scalars['UUID'];
  package: Scalars['String'];
};

export type OrganizationOnboardingInput = {
  onboardingToken: Scalars['String'];
};

export type Organizations = {
  __typename?: 'Organizations';
  data: Array<Organization>;
  paginationInfo: PaginationInfo;
};

export type OrganizationsFilterInput = {
  search?: InputMaybe<Scalars['String']>;
};

export type OrganizationsInput = {
  filter?: InputMaybe<OrganizationsFilterInput>;
  pagination?: InputMaybe<PaginationInput>;
};

export type PaginationInfo = {
  __typename?: 'PaginationInfo';
  currentPage: Scalars['Int'];
  firstPage: Scalars['Int'];
  lastPage: Scalars['Int'];
  nextPage?: Maybe<Scalars['Int']>;
  previousPage?: Maybe<Scalars['Int']>;
  totalCount: Scalars['Int'];
};

export type PaginationInput = {
  limit?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  activeTimeSlot?: Maybe<TimeSlot>;
  customerNoShowHistoryByEmail: NoShowHistory;
  dashboardStats: DashboardStats;
  employee: Employee;
  employeeReservation?: Maybe<EmployeeReservation>;
  employees: Employees;
  freeServiceReservationTimeSlots: Array<TimeSlot>;
  me?: Maybe<Organization>;
  noShowList: Array<NoShowEntry>;
  onboardingOrganization?: Maybe<Scalars['Boolean']>;
  organization: Organization;
  organizationOnboarding: Organization;
  organizations: Organizations;
  reservation?: Maybe<Reservation>;
  searchCustomers: Array<Customer>;
  service: Service;
  serviceReservation?: Maybe<ServiceReservation>;
  tags: Array<Tag>;
  timeSlot?: Maybe<TimeSlot>;
  timeSlots: TimeSlots;
};


export type QueryActiveTimeSlotArgs = {
  input: ActiveTimeSlotInput;
};


export type QueryCustomerNoShowHistoryByEmailArgs = {
  input: CustomerNoShowHistoryInput;
};


export type QueryDashboardStatsArgs = {
  input: DashboardStatsInput;
};


export type QueryEmployeeArgs = {
  id: Scalars['UUID'];
};


export type QueryEmployeeReservationArgs = {
  input: EmployeeReservationInput;
};


export type QueryEmployeesArgs = {
  input?: InputMaybe<EmployeesInput>;
};


export type QueryFreeServiceReservationTimeSlotsArgs = {
  input: FreeServiceReservationTimeSlotsInput;
};


export type QueryNoShowListArgs = {
  input: NoShowListInput;
};


export type QueryOnboardingOrganizationArgs = {
  onboardingToken?: InputMaybe<Scalars['UUID']>;
};


export type QueryOrganizationArgs = {
  id?: InputMaybe<Scalars['UUID']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryOrganizationOnboardingArgs = {
  input: OrganizationOnboardingInput;
};


export type QueryOrganizationsArgs = {
  input?: InputMaybe<OrganizationsInput>;
};


export type QueryReservationArgs = {
  input: ReservationInput;
};


export type QuerySearchCustomersArgs = {
  input: SearchCustomersInput;
};


export type QueryServiceArgs = {
  id: Scalars['UUID'];
};


export type QueryServiceReservationArgs = {
  input: ServiceReservationInput;
};


export type QueryTimeSlotArgs = {
  input: TimeSlotInput;
};


export type QueryTimeSlotsArgs = {
  input: TimeSlotsInput;
};

export type RangeDateInput = {
  from?: InputMaybe<Scalars['String']>;
  to?: InputMaybe<Scalars['String']>;
};

export type RangeFloatInput = {
  from?: InputMaybe<Scalars['Float']>;
  to?: InputMaybe<Scalars['Float']>;
};

export type RangeIntInput = {
  from?: InputMaybe<Scalars['Int']>;
  to?: InputMaybe<Scalars['Int']>;
};

export type ReorderEmployeesInput = {
  employeesIds: Array<Scalars['UUID']>;
  organizationId: Scalars['UUID'];
};

export type Reservation = {
  __typename?: 'Reservation';
  createdAtUtc: Datetime;
  date: Scalars['String'];
  description: Scalars['String'];
  email: Scalars['String'];
  employee: Employee;
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  reason: Scalars['String'];
  status: ReservationStatus;
  timeSlot: TimeSlot;
  updatedAtUtc?: Maybe<Datetime>;
};

export type ReservationInput = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export enum ReservationStatus {
  Active = 'active',
  CancelledByEmployee = 'cancelled_by_employee',
  CancelledByPatient = 'cancelled_by_patient',
  Done = 'done'
}

export type ResetPasswordInput = {
  password: Scalars['String'];
  resetPasswordToken: Scalars['String'];
};

export type SearchCustomersInput = {
  organizationId: Scalars['UUID'];
  query: Scalars['String'];
};

export type Service = {
  __typename?: 'Service';
  amount?: Maybe<Scalars['Float']>;
  attachment?: Maybe<Attachment>;
  description?: Maybe<Scalars['String']>;
  descriptionTranslations?: Maybe<Scalars['JSONObject']>;
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['UUID'];
  name?: Maybe<Scalars['String']>;
  nameTranslations?: Maybe<Scalars['JSONObject']>;
  position?: Maybe<Scalars['Int']>;
  tags: Array<Tag>;
  translatedDescription?: Maybe<Scalars['String']>;
  translatedName?: Maybe<Scalars['String']>;
};


export type ServiceTranslatedDescriptionArgs = {
  lang?: InputMaybe<Scalars['String']>;
};


export type ServiceTranslatedNameArgs = {
  lang?: InputMaybe<Scalars['String']>;
};

export type ServiceCopy = {
  __typename?: 'ServiceCopy';
  amount?: Maybe<Scalars['Float']>;
  attachment?: Maybe<Attachment>;
  description?: Maybe<Scalars['String']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['UUID']>;
  name?: Maybe<Scalars['String']>;
  position?: Maybe<Scalars['Int']>;
};

export type ServiceReservation = {
  __typename?: 'ServiceReservation';
  createdAtUtc: Datetime;
  customerLanguage?: Maybe<Scalars['String']>;
  customerNoShowHistory: NoShowHistory;
  date: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  employee: Employee;
  firstName?: Maybe<Scalars['String']>;
  id: Scalars['UUID'];
  lastName?: Maybe<Scalars['String']>;
  noShowAtUtc?: Maybe<Scalars['String']>;
  noShowType?: Maybe<NoShowType>;
  phoneNumber?: Maybe<Scalars['String']>;
  reason?: Maybe<Scalars['String']>;
  service?: Maybe<ServiceCopy>;
  status: ServiceReservationStatus;
  timeSlots: Array<TimeSlot>;
  updatedAtUtc?: Maybe<Datetime>;
};

export type ServiceReservationInput = {
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
};

export enum ServiceReservationStatus {
  Active = 'active',
  CancelledByCustomer = 'cancelled_by_customer',
  CancelledByEmployee = 'cancelled_by_employee',
  Done = 'done'
}

export type ShortAppointment = {
  __typename?: 'ShortAppointment';
  createdAtUtc: Datetime;
  id: Scalars['UUID'];
  position: Scalars['Int'];
};

export type SignInAsOrganizationInput = {
  organizationId: Scalars['UUID'];
};

export type SignInAsOrganizationResponse = {
  __typename?: 'SignInAsOrganizationResponse';
  organization: Organization;
  token: Scalars['String'];
};

export type SimplifiedReservation = {
  __typename?: 'SimplifiedReservation';
  email: Scalars['String'];
  id: Scalars['UUID'];
};

export type SlotBookability = {
  __typename?: 'SlotBookability';
  date: Scalars['String'];
  hasBookableSlot: Scalars['Boolean'];
};

export type Tag = {
  __typename?: 'Tag';
  id: Scalars['UUID'];
  name: Scalars['String'];
  nameTranslations?: Maybe<Scalars['JSONObject']>;
  position: Scalars['Int'];
  translatedName?: Maybe<Scalars['String']>;
};


export type TagTranslatedNameArgs = {
  lang?: InputMaybe<Scalars['String']>;
};

export type TimeSlot = {
  __typename?: 'TimeSlot';
  createdAtUtc: Datetime;
  employee: Employee;
  employeeReservation?: Maybe<EmployeeReservation>;
  endAtUtc: Datetime;
  entityLimitMax?: Maybe<Scalars['Int']>;
  hasTemplate: Scalars['Boolean'];
  id: Scalars['UUID'];
  localEndTime: Scalars['String'];
  localStartTime: Scalars['String'];
  reservation?: Maybe<Reservation>;
  serviceReservation?: Maybe<ServiceReservation>;
  startAtUtc: Datetime;
  title?: Maybe<Scalars['String']>;
  type?: Maybe<Scalars['String']>;
  updatedAtUtc?: Maybe<Datetime>;
};

export type TimeSlotInput = {
  employeeId: Scalars['UUID'];
  id: Scalars['UUID'];
};

export type TimeSlots = {
  __typename?: 'TimeSlots';
  slots: Array<TimeSlot>;
};

export type TimeSlotsInput = {
  employeeId: Scalars['UUID'];
  fromDate: Scalars['String'];
  organizationId: Scalars['UUID'];
  toDate: Scalars['String'];
  type?: InputMaybe<Scalars['String']>;
};

export type TopEmployee = {
  __typename?: 'TopEmployee';
  bookingsCount: Scalars['Int'];
  employeeId: Scalars['UUID'];
  employeeName: Scalars['String'];
  occupancyRate: Scalars['Float'];
  totalRevenue: Scalars['Float'];
};

export type TopService = {
  __typename?: 'TopService';
  bookingsCount: Scalars['Int'];
  serviceId: Scalars['UUID'];
  serviceName: Scalars['String'];
  totalRevenue: Scalars['Float'];
};

export type TrendDataPoint = {
  __typename?: 'TrendDataPoint';
  date: Scalars['String'];
  value: Scalars['Float'];
};

export type UnmarkNoShowInput = {
  id: Scalars['UUID'];
  organizationId: Scalars['UUID'];
};

export type UpdateAppointmentByCreatorInput = {
  description: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['UUID'];
  lastName: Scalars['String'];
  phoneNumber: Scalars['String'];
  reason: Scalars['String'];
};

export type UpdateAppointmentByOrganizationInput = {
  id: Scalars['UUID'];
  status?: InputMaybe<Scalars['String']>;
};

export type UpdateEmployeeInput = {
  description?: InputMaybe<Scalars['String']>;
  descriptionTranslations?: InputMaybe<Scalars['JSONObject']>;
  email?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  isReceivingReservationCreatedEmails?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  nameTranslations?: InputMaybe<Scalars['JSONObject']>;
  note?: InputMaybe<Scalars['String']>;
  organizationId: Scalars['UUID'];
  phoneNumber?: InputMaybe<Scalars['String']>;
  position?: InputMaybe<Scalars['Int']>;
  profilePictureAttachmentId?: InputMaybe<Scalars['UUID']>;
  servicesIds: Array<Scalars['UUID']>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type UpdateOrganizationInput = {
  daysInFutureAllowedToBook?: InputMaybe<Scalars['Int']>;
  defaultLanguage?: InputMaybe<Scalars['String']>;
  id: Scalars['UUID'];
  profilePictureAttachmentId?: InputMaybe<Scalars['UUID']>;
  supportedLanguages?: InputMaybe<Array<Scalars['String']>>;
};

export type UpdateServiceInput = {
  amount?: InputMaybe<Scalars['Float']>;
  attachmentId?: InputMaybe<Scalars['UUID']>;
  description?: InputMaybe<Scalars['String']>;
  descriptionTranslations?: InputMaybe<Scalars['JSONObject']>;
  duration?: InputMaybe<Scalars['Int']>;
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  nameTranslations?: InputMaybe<Scalars['JSONObject']>;
  organizationId: Scalars['UUID'];
  position?: InputMaybe<Scalars['Int']>;
  tagIds?: InputMaybe<Array<Scalars['UUID']>>;
};

export type UpdateTagInput = {
  id: Scalars['UUID'];
  name?: InputMaybe<Scalars['String']>;
  nameTranslations?: InputMaybe<Scalars['JSONObject']>;
  organizationId: Scalars['UUID'];
  position?: InputMaybe<Scalars['Int']>;
};

export type EmployeeReservationDetailQueryVariables = Exact<{
  input: EmployeeReservationInput;
}>;


export type EmployeeReservationDetailQuery = { __typename?: 'Query', employeeReservation?: { __typename?: 'EmployeeReservation', id: any, firstName: string, lastName: string, status: EmployeeReservationStatus, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, employee: { __typename?: 'Employee', id: any, name?: string | null, organization: { __typename?: 'Organization', id: any, name: string } }, timeSlot: { __typename?: 'TimeSlot', id: any, localStartTime: string, localEndTime: string, startAtUtc: { __typename?: 'Datetime', isoFormat: string } } } | null };

export type CancelEmployeeReservationMutationVariables = Exact<{
  input: CancelEmployeeReservationInput;
}>;


export type CancelEmployeeReservationMutation = { __typename?: 'Mutation', cancelEmployeeReservation: { __typename?: 'EmployeeReservation', id: any, status: EmployeeReservationStatus } };

export type TimeReservationDatesBookabilityQueryVariables = Exact<{
  employeeId: Scalars['UUID'];
  input: HasBookableSlotInput;
}>;


export type TimeReservationDatesBookabilityQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: any, areSlotsBookable: Array<{ __typename?: 'SlotBookability', date: string, hasBookableSlot: boolean }> } };

export type CancelServiceReservationMutationVariables = Exact<{
  input: CancelServiceReservationInput;
}>;


export type CancelServiceReservationMutation = { __typename?: 'Mutation', cancelServiceReservation: { __typename?: 'ServiceReservation', id: any, status: ServiceReservationStatus } };

export type AdminCreateServiceReservationMutationVariables = Exact<{
  input: AdminCreateServiceReservationInput;
}>;


export type AdminCreateServiceReservationMutation = { __typename?: 'Mutation', adminCreateServiceReservation: { __typename?: 'ServiceReservation', id: any } };

export type TimeReservationsEmployeesQueryVariables = Exact<{
  slug?: InputMaybe<Scalars['String']>;
}>;


export type TimeReservationsEmployeesQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, employees: Array<{ __typename?: 'Employee', id: any, name?: string | null, description?: string | null }> } };

export type TimeReservationsEmployeeSlotsQueryVariables = Exact<{
  employeeId: Scalars['UUID'];
  date: Scalars['String'];
}>;


export type TimeReservationsEmployeeSlotsQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: any, bookableSlots: Array<{ __typename?: 'TimeSlot', id: any, localStartTime: string, localEndTime: string }> } };

export type TimeReservationsCreateReservationMutationVariables = Exact<{
  input: CreateReservationInput;
}>;


export type TimeReservationsCreateReservationMutation = { __typename?: 'Mutation', createReservation: { __typename?: 'SimplifiedReservation', id: any, email: string } };

export type TimeReservationsTimeSlotDetailQueryVariables = Exact<{
  input: TimeSlotInput;
}>;


export type TimeReservationsTimeSlotDetailQuery = { __typename?: 'Query', timeSlot?: { __typename?: 'TimeSlot', id: any, localStartTime: string, localEndTime: string, startAtUtc: { __typename?: 'Datetime', isoFormat: string } } | null };

export type TimeReservationsEmployeeDetailQueryVariables = Exact<{
  id: Scalars['UUID'];
}>;


export type TimeReservationsEmployeeDetailQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: any, name?: string | null } };

export type TimeReservationReservationDetailQueryVariables = Exact<{
  input: ReservationInput;
}>;


export type TimeReservationReservationDetailQuery = { __typename?: 'Query', reservation?: { __typename?: 'Reservation', id: any, firstName: string, lastName: string, status: ReservationStatus, createdAtUtc: { __typename?: 'Datetime', isoFormat: string }, employee: { __typename?: 'Employee', id: any, name?: string | null, organization: { __typename?: 'Organization', id: any, name: string } }, timeSlot: { __typename?: 'TimeSlot', id: any, localStartTime: string, localEndTime: string, startAtUtc: { __typename?: 'Datetime', isoFormat: string } } } | null };

export type TimeReservationCancelReservationMutationVariables = Exact<{
  input: CancelReservationInput;
}>;


export type TimeReservationCancelReservationMutation = { __typename?: 'Mutation', cancelReservation: { __typename?: 'Reservation', id: any, status: ReservationStatus } };

export type CalendarViewQueryVariables = Exact<{
  input: TimeSlotsInput;
}>;


export type CalendarViewQuery = { __typename?: 'Query', timeSlots: { __typename?: 'TimeSlots', slots: Array<{ __typename?: 'TimeSlot', id: any, title?: string | null, type?: string | null, hasTemplate: boolean, entityLimitMax?: number | null, employeeReservation?: { __typename?: 'EmployeeReservation', id: any, firstName: string, lastName: string, email: string, phoneNumber: string, status: EmployeeReservationStatus, reason: string, description: string } | null, reservation?: { __typename?: 'Reservation', id: any, firstName: string, lastName: string, email: string, phoneNumber: string, status: ReservationStatus, reason: string, description: string } | null, serviceReservation?: { __typename?: 'ServiceReservation', id: any, firstName?: string | null, lastName?: string | null, email: string, phoneNumber?: string | null, status: ServiceReservationStatus, customerLanguage?: string | null, reason?: string | null, description?: string | null, noShowAtUtc?: string | null, noShowType?: NoShowType | null, service?: { __typename?: 'ServiceCopy', id?: any | null, amount?: number | null, name?: string | null, description?: string | null } | null, customerNoShowHistory: { __typename?: 'NoShowHistory', count: number, noShowCount: number, lateCancellationCount: number, windowMonths: number } } | null, startAtUtc: { __typename?: 'Datetime', isoFormat: string, utcFormat: string }, endAtUtc: { __typename?: 'Datetime', isoFormat: string, utcFormat: string } }> } };

export type EmployeesForCalendarViewQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['UUID']>;
  managementEmployeesInput?: InputMaybe<OrganizationEmployeesInput>;
}>;


export type EmployeesForCalendarViewQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, daysInFutureAllowedToBook: number, managementEmployees: Array<{ __typename?: 'Employee', id: any, name?: string | null }> } };

export type CalendarViewCreateTimeSlotMutationVariables = Exact<{
  input: CreateTimeSlotInput;
}>;


export type CalendarViewCreateTimeSlotMutation = { __typename?: 'Mutation', createTimeSlot?: { __typename?: 'TimeSlot', id: any } | null };

export type CalendarViewDeleteTimeSlotMutationVariables = Exact<{
  input: DeleteTimeSlotInput;
}>;


export type CalendarViewDeleteTimeSlotMutation = { __typename?: 'Mutation', deleteTimeSlot?: boolean | null };

export type CalendarViewActiveTimeSlotQueryVariables = Exact<{
  input: ActiveTimeSlotInput;
}>;


export type CalendarViewActiveTimeSlotQuery = { __typename?: 'Query', activeTimeSlot?: { __typename?: 'TimeSlot', id: any, title?: string | null, localEndTime: string, localStartTime: string, type?: string | null, entityLimitMax?: number | null, employeeReservation?: { __typename?: 'EmployeeReservation', id: any, firstName: string, lastName: string, email: string, phoneNumber: string, status: EmployeeReservationStatus, reason: string, description: string } | null, reservation?: { __typename?: 'Reservation', id: any, firstName: string, lastName: string, email: string, phoneNumber: string, status: ReservationStatus, reason: string, description: string } | null, serviceReservation?: { __typename?: 'ServiceReservation', id: any, firstName?: string | null, lastName?: string | null, email: string, phoneNumber?: string | null, status: ServiceReservationStatus, customerLanguage?: string | null, reason?: string | null, description?: string | null, noShowAtUtc?: string | null, noShowType?: NoShowType | null, service?: { __typename?: 'ServiceCopy', id?: any | null, amount?: number | null, name?: string | null, description?: string | null } | null, customerNoShowHistory: { __typename?: 'NoShowHistory', count: number, noShowCount: number, lateCancellationCount: number, windowMonths: number } } | null } | null };

export type CalendarViewQueueAppointmentsQueryVariables = Exact<{
  input: TimeSlotsInput;
  appointmentsInput: EmployeeAppointmentsInput;
  appointmentsCountInput: EmployeeAppointmentsInput;
}>;


export type CalendarViewQueueAppointmentsQuery = { __typename?: 'Query', timeSlots: { __typename?: 'TimeSlots', slots: Array<{ __typename?: 'TimeSlot', id: any, entityLimitMax?: number | null, employee: { __typename?: 'Employee', id: any, nextAppointmentPosition?: number | null, appointmentsCount: number, averageAppointmentTimeInSeconds?: number | null, currentAppointment?: { __typename?: 'Appointment', id: any, firstName: string, lastName: string, email: string, phoneNumber: string, position: number, status: AppointmentStatus, reason: string, description: string } | null, appointments: Array<{ __typename?: 'Appointment', id: any, firstName: string, lastName: string, email: string, phoneNumber: string, position: number, status: AppointmentStatus, reason: string, description: string, hasStarted?: boolean | null }> } }> } };

export type CalendarViewChangeTimeSlotMutationVariables = Exact<{
  input: ChangeTimeSlotInput;
}>;


export type CalendarViewChangeTimeSlotMutation = { __typename?: 'Mutation', changeTimeSlot: { __typename?: 'TimeSlot', id: any, startAtUtc: { __typename?: 'Datetime', isoFormat: string, utcFormat: string }, endAtUtc: { __typename?: 'Datetime', isoFormat: string, utcFormat: string } } };

export type CalendarViewCreateEmployeeReservationMutationVariables = Exact<{
  input: CreateEmployeeReservationInput;
}>;


export type CalendarViewCreateEmployeeReservationMutation = { __typename?: 'Mutation', createEmployeeReservation: { __typename?: 'EmployeeReservation', id: any, firstName: string, lastName: string, email: string, phoneNumber: string, status: EmployeeReservationStatus, reason: string, description: string } };

export type CalendarViewChangeTimeSlotEntityLimitMaxMutationVariables = Exact<{
  input: ChangeTimeSlotEntityMaxLimitInput;
}>;


export type CalendarViewChangeTimeSlotEntityLimitMaxMutation = { __typename?: 'Mutation', changeTimeSlotEntityLimitMax: { __typename?: 'TimeSlot', id: any, entityLimitMax?: number | null } };

export type SearchCustomersQueryVariables = Exact<{
  input: SearchCustomersInput;
}>;


export type SearchCustomersQuery = { __typename?: 'Query', searchCustomers: Array<{ __typename?: 'Customer', firstName?: string | null, lastName?: string | null, email: string, phoneNumber?: string | null }> };

export type DashboardStatsQueryVariables = Exact<{
  input: DashboardStatsInput;
}>;


export type DashboardStatsQuery = { __typename?: 'Query', dashboardStats: { __typename?: 'DashboardStats', kpis: { __typename?: 'DashboardKPIs', totalBookings: number, totalRevenue: number, activeCustomers: number, cancellationRate: number, bookingsChange?: number | null, revenueChange?: number | null, customersChange?: number | null, cancellationRateChange?: number | null }, trends: { __typename?: 'DashboardTrends', revenueTrend: Array<{ __typename?: 'TrendDataPoint', date: string, value: number }>, bookingsTrend: Array<{ __typename?: 'TrendDataPoint', date: string, value: number }> }, topLists: { __typename?: 'DashboardTopLists', topServices: Array<{ __typename?: 'TopService', serviceId: any, serviceName: string, bookingsCount: number, totalRevenue: number }>, topEmployees: Array<{ __typename?: 'TopEmployee', employeeId: any, employeeName: string, bookingsCount: number, totalRevenue: number, occupancyRate: number }> }, monthlyOccupancy: { __typename?: 'MonthlyOccupancyHeatmap', days: Array<{ __typename?: 'DayOccupancy', date: string, occupancyRate: number, occupiedHours: number, availableHours: number }> } } };

export type EmployeeQueryVariables = Exact<{
  employeeId: Scalars['UUID'];
}>;


export type EmployeeQuery = { __typename?: 'Query', employee: { __typename?: 'Employee', id: any, position: number, email?: string | null, name?: string | null, description?: string | null, nameTranslations?: any | null, descriptionTranslations?: any | null, phoneNumber?: string | null, isReceivingReservationCreatedEmails: boolean, services: Array<{ __typename?: 'Service', id: any, name?: string | null, amount?: number | null }>, tags: Array<{ __typename?: 'Tag', id: any, name: string, position: number }>, profilePictureAttachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null, organization: { __typename?: 'Organization', id: any, name: string } } };

export type UpdateEmployeeMutationVariables = Exact<{
  input: UpdateEmployeeInput;
  employeesInput?: InputMaybe<OrganizationEmployeesInput>;
}>;


export type UpdateEmployeeMutation = { __typename?: 'Mutation', updateEmployee: { __typename?: 'Employee', id: any, position: number, email?: string | null, name?: string | null, description?: string | null, nameTranslations?: any | null, descriptionTranslations?: any | null, phoneNumber?: string | null, isReceivingReservationCreatedEmails: boolean, services: Array<{ __typename?: 'Service', id: any, name?: string | null, amount?: number | null }>, organization: { __typename?: 'Organization', id: any, name: string, managementEmployees: Array<{ __typename?: 'Employee', id: any, position: number }> }, profilePictureAttachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null } };

export type AddEmployeeMutationVariables = Exact<{
  input: AddEmployeeInput;
  employeesInput?: InputMaybe<OrganizationEmployeesInput>;
}>;


export type AddEmployeeMutation = { __typename?: 'Mutation', addEmployee: { __typename?: 'Organization', id: any, services: Array<{ __typename?: 'Service', id: any, name?: string | null, amount?: number | null }>, managementEmployees: Array<{ __typename?: 'Employee', position: number, id: any, email?: string | null, name?: string | null, description?: string | null, nameTranslations?: any | null, descriptionTranslations?: any | null, phoneNumber?: string | null, isReceivingReservationCreatedEmails: boolean, profilePictureAttachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null, organization: { __typename?: 'Organization', id: any, name: string } }> } };

export type DeleteEmployeeMutationVariables = Exact<{
  input: DeleteEmployeeInput;
  employeesInput?: InputMaybe<OrganizationEmployeesInput>;
}>;


export type DeleteEmployeeMutation = { __typename?: 'Mutation', deleteEmployee: { __typename?: 'Organization', id: any, managementEmployees: Array<{ __typename?: 'Employee', position: number, id: any, email?: string | null, name?: string | null, description?: string | null, nameTranslations?: any | null, descriptionTranslations?: any | null, phoneNumber?: string | null, isReceivingReservationCreatedEmails: boolean, profilePictureAttachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null, organization: { __typename?: 'Organization', id: any, name: string } }> } };

export type ExtraPackagesQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['UUID']>;
}>;


export type ExtraPackagesQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, activeExtraPackages: Array<string> } };

export type EmployeeDetailsFragment = { __typename?: 'Employee', id: any, email?: string | null, name?: string | null, description?: string | null, nameTranslations?: any | null, descriptionTranslations?: any | null, phoneNumber?: string | null, isReceivingReservationCreatedEmails: boolean, profilePictureAttachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null, organization: { __typename?: 'Organization', id: any, name: string } };

export type MeQueryVariables = Exact<{ [key: string]: never; }>;


export type MeQuery = { __typename?: 'Query', me?: { __typename?: 'Organization', id: any, name: string, slug: string, email?: string | null, ico?: string | null, city: string, street: string, activeExtraPackages: Array<string>, defaultLanguage: string, supportedLanguages: Array<string>, profilePictureAttachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null } | null };

export type SendResetPasswordEmailMutationVariables = Exact<{
  email: Scalars['String'];
  recaptchaToken: Scalars['String'];
}>;


export type SendResetPasswordEmailMutation = { __typename?: 'Mutation', sendResetPasswordEmail?: boolean | null };

export type ResetPasswordMutationVariables = Exact<{
  input: ResetPasswordInput;
}>;


export type ResetPasswordMutation = { __typename?: 'Mutation', resetPassword?: boolean | null };

export type CustomerNoShowHistoryByEmailQueryVariables = Exact<{
  input: CustomerNoShowHistoryInput;
}>;


export type CustomerNoShowHistoryByEmailQuery = { __typename?: 'Query', customerNoShowHistoryByEmail: { __typename?: 'NoShowHistory', count: number, noShowCount: number, lateCancellationCount: number, windowMonths: number } };

export type NoShowListQueryVariables = Exact<{
  input: NoShowListInput;
}>;


export type NoShowListQuery = { __typename?: 'Query', noShowList: Array<{ __typename?: 'NoShowEntry', reservationId: any, firstName?: string | null, lastName?: string | null, email?: string | null, phoneNumber?: string | null, serviceName?: string | null, serviceAmount?: number | null, date: string, localStartTime?: string | null, startAtUtc?: string | null, noShowType: NoShowType, noShowAtUtc: string, markedBy: string }> };

export type MarkServiceReservationNoShowMutationVariables = Exact<{
  input: MarkNoShowInput;
}>;


export type MarkServiceReservationNoShowMutation = { __typename?: 'Mutation', markServiceReservationNoShow: { __typename?: 'ServiceReservation', id: any, noShowAtUtc?: string | null, noShowType?: NoShowType | null } };

export type UnmarkServiceReservationNoShowMutationVariables = Exact<{
  input: UnmarkNoShowInput;
}>;


export type UnmarkServiceReservationNoShowMutation = { __typename?: 'Mutation', unmarkServiceReservationNoShow: { __typename?: 'ServiceReservation', id: any, noShowAtUtc?: string | null, noShowType?: NoShowType | null } };

export type OrganizationBySlugQueryVariables = Exact<{
  organizationSlug?: InputMaybe<Scalars['String']>;
}>;


export type OrganizationBySlugQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any } };

export type OrganizationStaticDataQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['UUID']>;
  organizationSlug?: InputMaybe<Scalars['String']>;
}>;


export type OrganizationStaticDataQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, slug: string, name: string, city: string, street: string, note?: string | null } };

export type GetAppointmentOrganizationDataQueryVariables = Exact<{
  organizationId?: InputMaybe<Scalars['UUID']>;
  organizationSlug?: InputMaybe<Scalars['String']>;
}>;


export type GetAppointmentOrganizationDataQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, name: string, isOfferingAnyQueue: boolean, isOfferingAnyBookable: boolean } };

export type DashboardOrganizationGeneralInformationQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type DashboardOrganizationGeneralInformationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, daysInFutureAllowedToBook: number, defaultLanguage: string, supportedLanguages: Array<string> } };

export type OrganizationQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
  employeesInput?: InputMaybe<OrganizationEmployeesInput>;
}>;


export type OrganizationQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, slug: string, name: string, city: string, street: string, email?: string | null, employees: Array<{ __typename?: 'Employee', id: any, description?: string | null, name?: string | null, status: string, profilePictureAttachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null }> } };

export type OrganizationEmployeesQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
  input?: InputMaybe<OrganizationEmployeesInput>;
}>;


export type OrganizationEmployeesQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, managementEmployees: Array<{ __typename?: 'Employee', id: any, email?: string | null, name?: string | null, description?: string | null, status: string, position: number, profilePictureAttachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null, organization: { __typename?: 'Organization', id: any, name: string } }> } };

export type OrganizationServicesQueryVariables = Exact<{
  organizationId: Scalars['UUID'];
}>;


export type OrganizationServicesQuery = { __typename?: 'Query', organization: { __typename?: 'Organization', id: any, services: Array<{ __typename?: 'Service', id: any, name?: string | null, description?: string | null, amount?: number | null, attachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null }> } };

export type UpdateOrganizationMutationVariables = Exact<{
  input: UpdateOrganizationInput;
}>;


export type UpdateOrganizationMutation = { __typename?: 'Mutation', updateOrganization: { __typename?: 'Organization', id: any, daysInFutureAllowedToBook: number, defaultLanguage: string, supportedLanguages: Array<string> } };

export type OrganizationOnboardingQueryVariables = Exact<{
  input: OrganizationOnboardingInput;
}>;


export type OrganizationOnboardingQuery = { __typename?: 'Query', organizationOnboarding: { __typename?: 'Organization', id: any, name: string, createdAtUtc: { __typename?: 'Datetime', isoFormat: string } } };

export type OnboardOrganizationMutationVariables = Exact<{
  input: OnboardOrganizationInput;
}>;


export type OnboardOrganizationMutation = { __typename?: 'Mutation', onboardOrganization: { __typename?: 'Organization', id: any } };

export type ServiceQueryVariables = Exact<{
  serviceId: Scalars['UUID'];
}>;


export type ServiceQuery = { __typename?: 'Query', service: { __typename?: 'Service', id: any, name?: string | null, description?: string | null, nameTranslations?: any | null, descriptionTranslations?: any | null, amount?: number | null, duration?: number | null, position?: number | null, attachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null, tags: Array<{ __typename?: 'Tag', id: any, name: string, position: number }> } };

export type AddServiceMutationVariables = Exact<{
  input: AddServiceInput;
}>;


export type AddServiceMutation = { __typename?: 'Mutation', addService: { __typename?: 'Organization', id: any, services: Array<{ __typename?: 'Service', id: any, name?: string | null, description?: string | null, amount?: number | null, duration?: number | null, position?: number | null, attachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null }> } };

export type UpdateServiceMutationVariables = Exact<{
  input: UpdateServiceInput;
}>;


export type UpdateServiceMutation = { __typename?: 'Mutation', updateService: { __typename?: 'Organization', id: any, services: Array<{ __typename?: 'Service', id: any, name?: string | null, description?: string | null, amount?: number | null, duration?: number | null, position?: number | null, attachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null }> } };

export type DeleteServiceMutationVariables = Exact<{
  input: DeleteServiceInput;
}>;


export type DeleteServiceMutation = { __typename?: 'Mutation', deleteService: { __typename?: 'Organization', id: any, services: Array<{ __typename?: 'Service', id: any, name?: string | null, description?: string | null, amount?: number | null, duration?: number | null, position?: number | null, attachment?: { __typename?: 'Attachment', id: any, publicUrl: string } | null }> } };

export type TagsQueryVariables = Exact<{ [key: string]: never; }>;


export type TagsQuery = { __typename?: 'Query', tags: Array<{ __typename?: 'Tag', id: any, name: string, nameTranslations?: any | null, position: number }> };

export type AddTagMutationVariables = Exact<{
  input: AddTagInput;
}>;


export type AddTagMutation = { __typename?: 'Mutation', addTag: { __typename?: 'Organization', id: any, services: Array<{ __typename?: 'Service', id: any, name?: string | null, tags: Array<{ __typename?: 'Tag', id: any, name: string, position: number }> }> } };

export type UpdateTagMutationVariables = Exact<{
  input: UpdateTagInput;
}>;


export type UpdateTagMutation = { __typename?: 'Mutation', updateTag: { __typename?: 'Organization', id: any, services: Array<{ __typename?: 'Service', id: any, name?: string | null, tags: Array<{ __typename?: 'Tag', id: any, name: string, position: number }> }> } };

export type DeleteTagMutationVariables = Exact<{
  input: DeleteTagInput;
}>;


export type DeleteTagMutation = { __typename?: 'Mutation', deleteTag: { __typename?: 'Organization', id: any, services: Array<{ __typename?: 'Service', id: any, name?: string | null, tags: Array<{ __typename?: 'Tag', id: any, name: string, position: number }> }> } };

export const EmployeeDetailsFragmentDoc = gql`
    fragment EmployeeDetails on Employee {
  id
  email
  name
  description
  nameTranslations
  descriptionTranslations
  phoneNumber
  profilePictureAttachment {
    id
    publicUrl
  }
  isReceivingReservationCreatedEmails
  organization {
    id
    name
  }
}
    `;
export const EmployeeReservationDetailDocument = gql`
    query EmployeeReservationDetail($input: EmployeeReservationInput!) {
  employeeReservation(input: $input) {
    id
    firstName
    lastName
    createdAtUtc {
      isoFormat
    }
    status
    employee {
      id
      name
      organization {
        id
        name
      }
    }
    timeSlot {
      id
      localStartTime
      localEndTime
      startAtUtc {
        isoFormat
      }
    }
  }
}
    `;

/**
 * __useEmployeeReservationDetailQuery__
 *
 * To run a query within a React component, call `useEmployeeReservationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeReservationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeReservationDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useEmployeeReservationDetailQuery(baseOptions: Apollo.QueryHookOptions<EmployeeReservationDetailQuery, EmployeeReservationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeReservationDetailQuery, EmployeeReservationDetailQueryVariables>(EmployeeReservationDetailDocument, options);
      }
export function useEmployeeReservationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeReservationDetailQuery, EmployeeReservationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeReservationDetailQuery, EmployeeReservationDetailQueryVariables>(EmployeeReservationDetailDocument, options);
        }
export type EmployeeReservationDetailQueryHookResult = ReturnType<typeof useEmployeeReservationDetailQuery>;
export type EmployeeReservationDetailLazyQueryHookResult = ReturnType<typeof useEmployeeReservationDetailLazyQuery>;
export type EmployeeReservationDetailQueryResult = Apollo.QueryResult<EmployeeReservationDetailQuery, EmployeeReservationDetailQueryVariables>;
export const CancelEmployeeReservationDocument = gql`
    mutation CancelEmployeeReservation($input: CancelEmployeeReservationInput!) {
  cancelEmployeeReservation(input: $input) {
    id
    status
  }
}
    `;
export type CancelEmployeeReservationMutationFn = Apollo.MutationFunction<CancelEmployeeReservationMutation, CancelEmployeeReservationMutationVariables>;

/**
 * __useCancelEmployeeReservationMutation__
 *
 * To run a mutation, you first call `useCancelEmployeeReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelEmployeeReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelEmployeeReservationMutation, { data, loading, error }] = useCancelEmployeeReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelEmployeeReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelEmployeeReservationMutation, CancelEmployeeReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelEmployeeReservationMutation, CancelEmployeeReservationMutationVariables>(CancelEmployeeReservationDocument, options);
      }
export type CancelEmployeeReservationMutationHookResult = ReturnType<typeof useCancelEmployeeReservationMutation>;
export type CancelEmployeeReservationMutationResult = Apollo.MutationResult<CancelEmployeeReservationMutation>;
export type CancelEmployeeReservationMutationOptions = Apollo.BaseMutationOptions<CancelEmployeeReservationMutation, CancelEmployeeReservationMutationVariables>;
export const TimeReservationDatesBookabilityDocument = gql`
    query TimeReservationDatesBookability($employeeId: UUID!, $input: HasBookableSlotInput!) {
  employee(id: $employeeId) {
    id
    areSlotsBookable(input: $input) {
      date
      hasBookableSlot
    }
  }
}
    `;

/**
 * __useTimeReservationDatesBookabilityQuery__
 *
 * To run a query within a React component, call `useTimeReservationDatesBookabilityQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReservationDatesBookabilityQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReservationDatesBookabilityQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeReservationDatesBookabilityQuery(baseOptions: Apollo.QueryHookOptions<TimeReservationDatesBookabilityQuery, TimeReservationDatesBookabilityQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeReservationDatesBookabilityQuery, TimeReservationDatesBookabilityQueryVariables>(TimeReservationDatesBookabilityDocument, options);
      }
export function useTimeReservationDatesBookabilityLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeReservationDatesBookabilityQuery, TimeReservationDatesBookabilityQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeReservationDatesBookabilityQuery, TimeReservationDatesBookabilityQueryVariables>(TimeReservationDatesBookabilityDocument, options);
        }
export type TimeReservationDatesBookabilityQueryHookResult = ReturnType<typeof useTimeReservationDatesBookabilityQuery>;
export type TimeReservationDatesBookabilityLazyQueryHookResult = ReturnType<typeof useTimeReservationDatesBookabilityLazyQuery>;
export type TimeReservationDatesBookabilityQueryResult = Apollo.QueryResult<TimeReservationDatesBookabilityQuery, TimeReservationDatesBookabilityQueryVariables>;
export const CancelServiceReservationDocument = gql`
    mutation CancelServiceReservation($input: CancelServiceReservationInput!) {
  cancelServiceReservation(input: $input) {
    id
    status
  }
}
    `;
export type CancelServiceReservationMutationFn = Apollo.MutationFunction<CancelServiceReservationMutation, CancelServiceReservationMutationVariables>;

/**
 * __useCancelServiceReservationMutation__
 *
 * To run a mutation, you first call `useCancelServiceReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCancelServiceReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [cancelServiceReservationMutation, { data, loading, error }] = useCancelServiceReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCancelServiceReservationMutation(baseOptions?: Apollo.MutationHookOptions<CancelServiceReservationMutation, CancelServiceReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CancelServiceReservationMutation, CancelServiceReservationMutationVariables>(CancelServiceReservationDocument, options);
      }
export type CancelServiceReservationMutationHookResult = ReturnType<typeof useCancelServiceReservationMutation>;
export type CancelServiceReservationMutationResult = Apollo.MutationResult<CancelServiceReservationMutation>;
export type CancelServiceReservationMutationOptions = Apollo.BaseMutationOptions<CancelServiceReservationMutation, CancelServiceReservationMutationVariables>;
export const AdminCreateServiceReservationDocument = gql`
    mutation AdminCreateServiceReservation($input: AdminCreateServiceReservationInput!) {
  adminCreateServiceReservation(input: $input) {
    id
  }
}
    `;
export type AdminCreateServiceReservationMutationFn = Apollo.MutationFunction<AdminCreateServiceReservationMutation, AdminCreateServiceReservationMutationVariables>;

/**
 * __useAdminCreateServiceReservationMutation__
 *
 * To run a mutation, you first call `useAdminCreateServiceReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAdminCreateServiceReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [adminCreateServiceReservationMutation, { data, loading, error }] = useAdminCreateServiceReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAdminCreateServiceReservationMutation(baseOptions?: Apollo.MutationHookOptions<AdminCreateServiceReservationMutation, AdminCreateServiceReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AdminCreateServiceReservationMutation, AdminCreateServiceReservationMutationVariables>(AdminCreateServiceReservationDocument, options);
      }
export type AdminCreateServiceReservationMutationHookResult = ReturnType<typeof useAdminCreateServiceReservationMutation>;
export type AdminCreateServiceReservationMutationResult = Apollo.MutationResult<AdminCreateServiceReservationMutation>;
export type AdminCreateServiceReservationMutationOptions = Apollo.BaseMutationOptions<AdminCreateServiceReservationMutation, AdminCreateServiceReservationMutationVariables>;
export const TimeReservationsEmployeesDocument = gql`
    query TimeReservationsEmployees($slug: String) {
  organization(slug: $slug) {
    id
    employees {
      id
      name
      description
    }
  }
}
    `;

/**
 * __useTimeReservationsEmployeesQuery__
 *
 * To run a query within a React component, call `useTimeReservationsEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReservationsEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReservationsEmployeesQuery({
 *   variables: {
 *      slug: // value for 'slug'
 *   },
 * });
 */
export function useTimeReservationsEmployeesQuery(baseOptions?: Apollo.QueryHookOptions<TimeReservationsEmployeesQuery, TimeReservationsEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeReservationsEmployeesQuery, TimeReservationsEmployeesQueryVariables>(TimeReservationsEmployeesDocument, options);
      }
export function useTimeReservationsEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeReservationsEmployeesQuery, TimeReservationsEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeReservationsEmployeesQuery, TimeReservationsEmployeesQueryVariables>(TimeReservationsEmployeesDocument, options);
        }
export type TimeReservationsEmployeesQueryHookResult = ReturnType<typeof useTimeReservationsEmployeesQuery>;
export type TimeReservationsEmployeesLazyQueryHookResult = ReturnType<typeof useTimeReservationsEmployeesLazyQuery>;
export type TimeReservationsEmployeesQueryResult = Apollo.QueryResult<TimeReservationsEmployeesQuery, TimeReservationsEmployeesQueryVariables>;
export const TimeReservationsEmployeeSlotsDocument = gql`
    query TimeReservationsEmployeeSlots($employeeId: UUID!, $date: String!) {
  employee(id: $employeeId) {
    id
    bookableSlots(date: $date) {
      id
      localStartTime
      localEndTime
    }
  }
}
    `;

/**
 * __useTimeReservationsEmployeeSlotsQuery__
 *
 * To run a query within a React component, call `useTimeReservationsEmployeeSlotsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReservationsEmployeeSlotsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReservationsEmployeeSlotsQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *      date: // value for 'date'
 *   },
 * });
 */
export function useTimeReservationsEmployeeSlotsQuery(baseOptions: Apollo.QueryHookOptions<TimeReservationsEmployeeSlotsQuery, TimeReservationsEmployeeSlotsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeReservationsEmployeeSlotsQuery, TimeReservationsEmployeeSlotsQueryVariables>(TimeReservationsEmployeeSlotsDocument, options);
      }
export function useTimeReservationsEmployeeSlotsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeReservationsEmployeeSlotsQuery, TimeReservationsEmployeeSlotsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeReservationsEmployeeSlotsQuery, TimeReservationsEmployeeSlotsQueryVariables>(TimeReservationsEmployeeSlotsDocument, options);
        }
export type TimeReservationsEmployeeSlotsQueryHookResult = ReturnType<typeof useTimeReservationsEmployeeSlotsQuery>;
export type TimeReservationsEmployeeSlotsLazyQueryHookResult = ReturnType<typeof useTimeReservationsEmployeeSlotsLazyQuery>;
export type TimeReservationsEmployeeSlotsQueryResult = Apollo.QueryResult<TimeReservationsEmployeeSlotsQuery, TimeReservationsEmployeeSlotsQueryVariables>;
export const TimeReservationsCreateReservationDocument = gql`
    mutation TimeReservationsCreateReservation($input: CreateReservationInput!) {
  createReservation(input: $input) {
    id
    email
  }
}
    `;
export type TimeReservationsCreateReservationMutationFn = Apollo.MutationFunction<TimeReservationsCreateReservationMutation, TimeReservationsCreateReservationMutationVariables>;

/**
 * __useTimeReservationsCreateReservationMutation__
 *
 * To run a mutation, you first call `useTimeReservationsCreateReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReservationsCreateReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReservationsCreateReservationMutation, { data, loading, error }] = useTimeReservationsCreateReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeReservationsCreateReservationMutation(baseOptions?: Apollo.MutationHookOptions<TimeReservationsCreateReservationMutation, TimeReservationsCreateReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TimeReservationsCreateReservationMutation, TimeReservationsCreateReservationMutationVariables>(TimeReservationsCreateReservationDocument, options);
      }
export type TimeReservationsCreateReservationMutationHookResult = ReturnType<typeof useTimeReservationsCreateReservationMutation>;
export type TimeReservationsCreateReservationMutationResult = Apollo.MutationResult<TimeReservationsCreateReservationMutation>;
export type TimeReservationsCreateReservationMutationOptions = Apollo.BaseMutationOptions<TimeReservationsCreateReservationMutation, TimeReservationsCreateReservationMutationVariables>;
export const TimeReservationsTimeSlotDetailDocument = gql`
    query TimeReservationsTimeSlotDetail($input: TimeSlotInput!) {
  timeSlot(input: $input) {
    id
    localStartTime
    localEndTime
    startAtUtc {
      isoFormat
    }
  }
}
    `;

/**
 * __useTimeReservationsTimeSlotDetailQuery__
 *
 * To run a query within a React component, call `useTimeReservationsTimeSlotDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReservationsTimeSlotDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReservationsTimeSlotDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeReservationsTimeSlotDetailQuery(baseOptions: Apollo.QueryHookOptions<TimeReservationsTimeSlotDetailQuery, TimeReservationsTimeSlotDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeReservationsTimeSlotDetailQuery, TimeReservationsTimeSlotDetailQueryVariables>(TimeReservationsTimeSlotDetailDocument, options);
      }
export function useTimeReservationsTimeSlotDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeReservationsTimeSlotDetailQuery, TimeReservationsTimeSlotDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeReservationsTimeSlotDetailQuery, TimeReservationsTimeSlotDetailQueryVariables>(TimeReservationsTimeSlotDetailDocument, options);
        }
export type TimeReservationsTimeSlotDetailQueryHookResult = ReturnType<typeof useTimeReservationsTimeSlotDetailQuery>;
export type TimeReservationsTimeSlotDetailLazyQueryHookResult = ReturnType<typeof useTimeReservationsTimeSlotDetailLazyQuery>;
export type TimeReservationsTimeSlotDetailQueryResult = Apollo.QueryResult<TimeReservationsTimeSlotDetailQuery, TimeReservationsTimeSlotDetailQueryVariables>;
export const TimeReservationsEmployeeDetailDocument = gql`
    query TimeReservationsEmployeeDetail($id: UUID!) {
  employee(id: $id) {
    id
    name
  }
}
    `;

/**
 * __useTimeReservationsEmployeeDetailQuery__
 *
 * To run a query within a React component, call `useTimeReservationsEmployeeDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReservationsEmployeeDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReservationsEmployeeDetailQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useTimeReservationsEmployeeDetailQuery(baseOptions: Apollo.QueryHookOptions<TimeReservationsEmployeeDetailQuery, TimeReservationsEmployeeDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeReservationsEmployeeDetailQuery, TimeReservationsEmployeeDetailQueryVariables>(TimeReservationsEmployeeDetailDocument, options);
      }
export function useTimeReservationsEmployeeDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeReservationsEmployeeDetailQuery, TimeReservationsEmployeeDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeReservationsEmployeeDetailQuery, TimeReservationsEmployeeDetailQueryVariables>(TimeReservationsEmployeeDetailDocument, options);
        }
export type TimeReservationsEmployeeDetailQueryHookResult = ReturnType<typeof useTimeReservationsEmployeeDetailQuery>;
export type TimeReservationsEmployeeDetailLazyQueryHookResult = ReturnType<typeof useTimeReservationsEmployeeDetailLazyQuery>;
export type TimeReservationsEmployeeDetailQueryResult = Apollo.QueryResult<TimeReservationsEmployeeDetailQuery, TimeReservationsEmployeeDetailQueryVariables>;
export const TimeReservationReservationDetailDocument = gql`
    query TimeReservationReservationDetail($input: ReservationInput!) {
  reservation(input: $input) {
    id
    firstName
    lastName
    createdAtUtc {
      isoFormat
    }
    status
    employee {
      id
      name
      organization {
        id
        name
      }
    }
    timeSlot {
      id
      localStartTime
      localEndTime
      startAtUtc {
        isoFormat
      }
    }
  }
}
    `;

/**
 * __useTimeReservationReservationDetailQuery__
 *
 * To run a query within a React component, call `useTimeReservationReservationDetailQuery` and pass it any options that fit your needs.
 * When your component renders, `useTimeReservationReservationDetailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTimeReservationReservationDetailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeReservationReservationDetailQuery(baseOptions: Apollo.QueryHookOptions<TimeReservationReservationDetailQuery, TimeReservationReservationDetailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TimeReservationReservationDetailQuery, TimeReservationReservationDetailQueryVariables>(TimeReservationReservationDetailDocument, options);
      }
export function useTimeReservationReservationDetailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TimeReservationReservationDetailQuery, TimeReservationReservationDetailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TimeReservationReservationDetailQuery, TimeReservationReservationDetailQueryVariables>(TimeReservationReservationDetailDocument, options);
        }
export type TimeReservationReservationDetailQueryHookResult = ReturnType<typeof useTimeReservationReservationDetailQuery>;
export type TimeReservationReservationDetailLazyQueryHookResult = ReturnType<typeof useTimeReservationReservationDetailLazyQuery>;
export type TimeReservationReservationDetailQueryResult = Apollo.QueryResult<TimeReservationReservationDetailQuery, TimeReservationReservationDetailQueryVariables>;
export const TimeReservationCancelReservationDocument = gql`
    mutation TimeReservationCancelReservation($input: CancelReservationInput!) {
  cancelReservation(input: $input) {
    id
    status
  }
}
    `;
export type TimeReservationCancelReservationMutationFn = Apollo.MutationFunction<TimeReservationCancelReservationMutation, TimeReservationCancelReservationMutationVariables>;

/**
 * __useTimeReservationCancelReservationMutation__
 *
 * To run a mutation, you first call `useTimeReservationCancelReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useTimeReservationCancelReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [timeReservationCancelReservationMutation, { data, loading, error }] = useTimeReservationCancelReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useTimeReservationCancelReservationMutation(baseOptions?: Apollo.MutationHookOptions<TimeReservationCancelReservationMutation, TimeReservationCancelReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<TimeReservationCancelReservationMutation, TimeReservationCancelReservationMutationVariables>(TimeReservationCancelReservationDocument, options);
      }
export type TimeReservationCancelReservationMutationHookResult = ReturnType<typeof useTimeReservationCancelReservationMutation>;
export type TimeReservationCancelReservationMutationResult = Apollo.MutationResult<TimeReservationCancelReservationMutation>;
export type TimeReservationCancelReservationMutationOptions = Apollo.BaseMutationOptions<TimeReservationCancelReservationMutation, TimeReservationCancelReservationMutationVariables>;
export const CalendarViewDocument = gql`
    query CalendarView($input: TimeSlotsInput!) {
  timeSlots(input: $input) {
    slots {
      id
      title
      type
      hasTemplate
      entityLimitMax
      employeeReservation {
        id
        firstName
        lastName
        email
        phoneNumber
        status
        reason
        description
      }
      reservation {
        id
        firstName
        lastName
        email
        phoneNumber
        status
        reason
        description
      }
      serviceReservation {
        id
        firstName
        lastName
        email
        phoneNumber
        status
        customerLanguage
        service {
          id
          amount
          name
          description
        }
        reason
        description
        noShowAtUtc
        noShowType
        customerNoShowHistory {
          count
          noShowCount
          lateCancellationCount
          windowMonths
        }
      }
      startAtUtc {
        isoFormat
        utcFormat
      }
      endAtUtc {
        isoFormat
        utcFormat
      }
    }
  }
}
    `;

/**
 * __useCalendarViewQuery__
 *
 * To run a query within a React component, call `useCalendarViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarViewQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarViewQuery(baseOptions: Apollo.QueryHookOptions<CalendarViewQuery, CalendarViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarViewQuery, CalendarViewQueryVariables>(CalendarViewDocument, options);
      }
export function useCalendarViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarViewQuery, CalendarViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarViewQuery, CalendarViewQueryVariables>(CalendarViewDocument, options);
        }
export type CalendarViewQueryHookResult = ReturnType<typeof useCalendarViewQuery>;
export type CalendarViewLazyQueryHookResult = ReturnType<typeof useCalendarViewLazyQuery>;
export type CalendarViewQueryResult = Apollo.QueryResult<CalendarViewQuery, CalendarViewQueryVariables>;
export const EmployeesForCalendarViewDocument = gql`
    query EmployeesForCalendarView($organizationId: UUID, $managementEmployeesInput: OrganizationEmployeesInput) {
  organization(id: $organizationId) {
    id
    daysInFutureAllowedToBook
    managementEmployees(input: $managementEmployeesInput) {
      id
      name
    }
  }
}
    `;

/**
 * __useEmployeesForCalendarViewQuery__
 *
 * To run a query within a React component, call `useEmployeesForCalendarViewQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeesForCalendarViewQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeesForCalendarViewQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      managementEmployeesInput: // value for 'managementEmployeesInput'
 *   },
 * });
 */
export function useEmployeesForCalendarViewQuery(baseOptions?: Apollo.QueryHookOptions<EmployeesForCalendarViewQuery, EmployeesForCalendarViewQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeesForCalendarViewQuery, EmployeesForCalendarViewQueryVariables>(EmployeesForCalendarViewDocument, options);
      }
export function useEmployeesForCalendarViewLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeesForCalendarViewQuery, EmployeesForCalendarViewQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeesForCalendarViewQuery, EmployeesForCalendarViewQueryVariables>(EmployeesForCalendarViewDocument, options);
        }
export type EmployeesForCalendarViewQueryHookResult = ReturnType<typeof useEmployeesForCalendarViewQuery>;
export type EmployeesForCalendarViewLazyQueryHookResult = ReturnType<typeof useEmployeesForCalendarViewLazyQuery>;
export type EmployeesForCalendarViewQueryResult = Apollo.QueryResult<EmployeesForCalendarViewQuery, EmployeesForCalendarViewQueryVariables>;
export const CalendarViewCreateTimeSlotDocument = gql`
    mutation CalendarViewCreateTimeSlot($input: CreateTimeSlotInput!) {
  createTimeSlot(input: $input) {
    id
  }
}
    `;
export type CalendarViewCreateTimeSlotMutationFn = Apollo.MutationFunction<CalendarViewCreateTimeSlotMutation, CalendarViewCreateTimeSlotMutationVariables>;

/**
 * __useCalendarViewCreateTimeSlotMutation__
 *
 * To run a mutation, you first call `useCalendarViewCreateTimeSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarViewCreateTimeSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarViewCreateTimeSlotMutation, { data, loading, error }] = useCalendarViewCreateTimeSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarViewCreateTimeSlotMutation(baseOptions?: Apollo.MutationHookOptions<CalendarViewCreateTimeSlotMutation, CalendarViewCreateTimeSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarViewCreateTimeSlotMutation, CalendarViewCreateTimeSlotMutationVariables>(CalendarViewCreateTimeSlotDocument, options);
      }
export type CalendarViewCreateTimeSlotMutationHookResult = ReturnType<typeof useCalendarViewCreateTimeSlotMutation>;
export type CalendarViewCreateTimeSlotMutationResult = Apollo.MutationResult<CalendarViewCreateTimeSlotMutation>;
export type CalendarViewCreateTimeSlotMutationOptions = Apollo.BaseMutationOptions<CalendarViewCreateTimeSlotMutation, CalendarViewCreateTimeSlotMutationVariables>;
export const CalendarViewDeleteTimeSlotDocument = gql`
    mutation CalendarViewDeleteTimeSlot($input: DeleteTimeSlotInput!) {
  deleteTimeSlot(input: $input)
}
    `;
export type CalendarViewDeleteTimeSlotMutationFn = Apollo.MutationFunction<CalendarViewDeleteTimeSlotMutation, CalendarViewDeleteTimeSlotMutationVariables>;

/**
 * __useCalendarViewDeleteTimeSlotMutation__
 *
 * To run a mutation, you first call `useCalendarViewDeleteTimeSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarViewDeleteTimeSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarViewDeleteTimeSlotMutation, { data, loading, error }] = useCalendarViewDeleteTimeSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarViewDeleteTimeSlotMutation(baseOptions?: Apollo.MutationHookOptions<CalendarViewDeleteTimeSlotMutation, CalendarViewDeleteTimeSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarViewDeleteTimeSlotMutation, CalendarViewDeleteTimeSlotMutationVariables>(CalendarViewDeleteTimeSlotDocument, options);
      }
export type CalendarViewDeleteTimeSlotMutationHookResult = ReturnType<typeof useCalendarViewDeleteTimeSlotMutation>;
export type CalendarViewDeleteTimeSlotMutationResult = Apollo.MutationResult<CalendarViewDeleteTimeSlotMutation>;
export type CalendarViewDeleteTimeSlotMutationOptions = Apollo.BaseMutationOptions<CalendarViewDeleteTimeSlotMutation, CalendarViewDeleteTimeSlotMutationVariables>;
export const CalendarViewActiveTimeSlotDocument = gql`
    query CalendarViewActiveTimeSlot($input: ActiveTimeSlotInput!) {
  activeTimeSlot(input: $input) {
    id
    title
    localEndTime
    localStartTime
    type
    entityLimitMax
    employeeReservation {
      id
      firstName
      lastName
      email
      phoneNumber
      status
      reason
      description
    }
    reservation {
      id
      firstName
      lastName
      email
      phoneNumber
      status
      reason
      description
    }
    serviceReservation {
      id
      firstName
      lastName
      email
      phoneNumber
      status
      customerLanguage
      reason
      description
      service {
        id
        amount
        name
        description
      }
      noShowAtUtc
      noShowType
      customerNoShowHistory {
        count
        noShowCount
        lateCancellationCount
        windowMonths
      }
    }
  }
}
    `;

/**
 * __useCalendarViewActiveTimeSlotQuery__
 *
 * To run a query within a React component, call `useCalendarViewActiveTimeSlotQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarViewActiveTimeSlotQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarViewActiveTimeSlotQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarViewActiveTimeSlotQuery(baseOptions: Apollo.QueryHookOptions<CalendarViewActiveTimeSlotQuery, CalendarViewActiveTimeSlotQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarViewActiveTimeSlotQuery, CalendarViewActiveTimeSlotQueryVariables>(CalendarViewActiveTimeSlotDocument, options);
      }
export function useCalendarViewActiveTimeSlotLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarViewActiveTimeSlotQuery, CalendarViewActiveTimeSlotQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarViewActiveTimeSlotQuery, CalendarViewActiveTimeSlotQueryVariables>(CalendarViewActiveTimeSlotDocument, options);
        }
export type CalendarViewActiveTimeSlotQueryHookResult = ReturnType<typeof useCalendarViewActiveTimeSlotQuery>;
export type CalendarViewActiveTimeSlotLazyQueryHookResult = ReturnType<typeof useCalendarViewActiveTimeSlotLazyQuery>;
export type CalendarViewActiveTimeSlotQueryResult = Apollo.QueryResult<CalendarViewActiveTimeSlotQuery, CalendarViewActiveTimeSlotQueryVariables>;
export const CalendarViewQueueAppointmentsDocument = gql`
    query CalendarViewQueueAppointments($input: TimeSlotsInput!, $appointmentsInput: EmployeeAppointmentsInput!, $appointmentsCountInput: EmployeeAppointmentsInput!) {
  timeSlots(input: $input) {
    slots {
      id
      entityLimitMax
      employee {
        id
        currentAppointment {
          id
          firstName
          lastName
          email
          phoneNumber
          position
          status
          reason
          description
        }
        nextAppointmentPosition
        appointmentsCount(input: $appointmentsCountInput)
        averageAppointmentTimeInSeconds
        appointments(input: $appointmentsInput) {
          id
          firstName
          lastName
          email
          phoneNumber
          position
          status
          reason
          description
          hasStarted
        }
      }
    }
  }
}
    `;

/**
 * __useCalendarViewQueueAppointmentsQuery__
 *
 * To run a query within a React component, call `useCalendarViewQueueAppointmentsQuery` and pass it any options that fit your needs.
 * When your component renders, `useCalendarViewQueueAppointmentsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCalendarViewQueueAppointmentsQuery({
 *   variables: {
 *      input: // value for 'input'
 *      appointmentsInput: // value for 'appointmentsInput'
 *      appointmentsCountInput: // value for 'appointmentsCountInput'
 *   },
 * });
 */
export function useCalendarViewQueueAppointmentsQuery(baseOptions: Apollo.QueryHookOptions<CalendarViewQueueAppointmentsQuery, CalendarViewQueueAppointmentsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CalendarViewQueueAppointmentsQuery, CalendarViewQueueAppointmentsQueryVariables>(CalendarViewQueueAppointmentsDocument, options);
      }
export function useCalendarViewQueueAppointmentsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CalendarViewQueueAppointmentsQuery, CalendarViewQueueAppointmentsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CalendarViewQueueAppointmentsQuery, CalendarViewQueueAppointmentsQueryVariables>(CalendarViewQueueAppointmentsDocument, options);
        }
export type CalendarViewQueueAppointmentsQueryHookResult = ReturnType<typeof useCalendarViewQueueAppointmentsQuery>;
export type CalendarViewQueueAppointmentsLazyQueryHookResult = ReturnType<typeof useCalendarViewQueueAppointmentsLazyQuery>;
export type CalendarViewQueueAppointmentsQueryResult = Apollo.QueryResult<CalendarViewQueueAppointmentsQuery, CalendarViewQueueAppointmentsQueryVariables>;
export const CalendarViewChangeTimeSlotDocument = gql`
    mutation CalendarViewChangeTimeSlot($input: ChangeTimeSlotInput!) {
  changeTimeSlot(input: $input) {
    id
    startAtUtc {
      isoFormat
      utcFormat
    }
    endAtUtc {
      isoFormat
      utcFormat
    }
  }
}
    `;
export type CalendarViewChangeTimeSlotMutationFn = Apollo.MutationFunction<CalendarViewChangeTimeSlotMutation, CalendarViewChangeTimeSlotMutationVariables>;

/**
 * __useCalendarViewChangeTimeSlotMutation__
 *
 * To run a mutation, you first call `useCalendarViewChangeTimeSlotMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarViewChangeTimeSlotMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarViewChangeTimeSlotMutation, { data, loading, error }] = useCalendarViewChangeTimeSlotMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarViewChangeTimeSlotMutation(baseOptions?: Apollo.MutationHookOptions<CalendarViewChangeTimeSlotMutation, CalendarViewChangeTimeSlotMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarViewChangeTimeSlotMutation, CalendarViewChangeTimeSlotMutationVariables>(CalendarViewChangeTimeSlotDocument, options);
      }
export type CalendarViewChangeTimeSlotMutationHookResult = ReturnType<typeof useCalendarViewChangeTimeSlotMutation>;
export type CalendarViewChangeTimeSlotMutationResult = Apollo.MutationResult<CalendarViewChangeTimeSlotMutation>;
export type CalendarViewChangeTimeSlotMutationOptions = Apollo.BaseMutationOptions<CalendarViewChangeTimeSlotMutation, CalendarViewChangeTimeSlotMutationVariables>;
export const CalendarViewCreateEmployeeReservationDocument = gql`
    mutation CalendarViewCreateEmployeeReservation($input: CreateEmployeeReservationInput!) {
  createEmployeeReservation(input: $input) {
    id
    firstName
    lastName
    email
    phoneNumber
    status
    reason
    description
  }
}
    `;
export type CalendarViewCreateEmployeeReservationMutationFn = Apollo.MutationFunction<CalendarViewCreateEmployeeReservationMutation, CalendarViewCreateEmployeeReservationMutationVariables>;

/**
 * __useCalendarViewCreateEmployeeReservationMutation__
 *
 * To run a mutation, you first call `useCalendarViewCreateEmployeeReservationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarViewCreateEmployeeReservationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarViewCreateEmployeeReservationMutation, { data, loading, error }] = useCalendarViewCreateEmployeeReservationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarViewCreateEmployeeReservationMutation(baseOptions?: Apollo.MutationHookOptions<CalendarViewCreateEmployeeReservationMutation, CalendarViewCreateEmployeeReservationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarViewCreateEmployeeReservationMutation, CalendarViewCreateEmployeeReservationMutationVariables>(CalendarViewCreateEmployeeReservationDocument, options);
      }
export type CalendarViewCreateEmployeeReservationMutationHookResult = ReturnType<typeof useCalendarViewCreateEmployeeReservationMutation>;
export type CalendarViewCreateEmployeeReservationMutationResult = Apollo.MutationResult<CalendarViewCreateEmployeeReservationMutation>;
export type CalendarViewCreateEmployeeReservationMutationOptions = Apollo.BaseMutationOptions<CalendarViewCreateEmployeeReservationMutation, CalendarViewCreateEmployeeReservationMutationVariables>;
export const CalendarViewChangeTimeSlotEntityLimitMaxDocument = gql`
    mutation CalendarViewChangeTimeSlotEntityLimitMax($input: ChangeTimeSlotEntityMaxLimitInput!) {
  changeTimeSlotEntityLimitMax(input: $input) {
    id
    entityLimitMax
  }
}
    `;
export type CalendarViewChangeTimeSlotEntityLimitMaxMutationFn = Apollo.MutationFunction<CalendarViewChangeTimeSlotEntityLimitMaxMutation, CalendarViewChangeTimeSlotEntityLimitMaxMutationVariables>;

/**
 * __useCalendarViewChangeTimeSlotEntityLimitMaxMutation__
 *
 * To run a mutation, you first call `useCalendarViewChangeTimeSlotEntityLimitMaxMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useCalendarViewChangeTimeSlotEntityLimitMaxMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [calendarViewChangeTimeSlotEntityLimitMaxMutation, { data, loading, error }] = useCalendarViewChangeTimeSlotEntityLimitMaxMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCalendarViewChangeTimeSlotEntityLimitMaxMutation(baseOptions?: Apollo.MutationHookOptions<CalendarViewChangeTimeSlotEntityLimitMaxMutation, CalendarViewChangeTimeSlotEntityLimitMaxMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<CalendarViewChangeTimeSlotEntityLimitMaxMutation, CalendarViewChangeTimeSlotEntityLimitMaxMutationVariables>(CalendarViewChangeTimeSlotEntityLimitMaxDocument, options);
      }
export type CalendarViewChangeTimeSlotEntityLimitMaxMutationHookResult = ReturnType<typeof useCalendarViewChangeTimeSlotEntityLimitMaxMutation>;
export type CalendarViewChangeTimeSlotEntityLimitMaxMutationResult = Apollo.MutationResult<CalendarViewChangeTimeSlotEntityLimitMaxMutation>;
export type CalendarViewChangeTimeSlotEntityLimitMaxMutationOptions = Apollo.BaseMutationOptions<CalendarViewChangeTimeSlotEntityLimitMaxMutation, CalendarViewChangeTimeSlotEntityLimitMaxMutationVariables>;
export const SearchCustomersDocument = gql`
    query SearchCustomers($input: SearchCustomersInput!) {
  searchCustomers(input: $input) {
    firstName
    lastName
    email
    phoneNumber
  }
}
    `;

/**
 * __useSearchCustomersQuery__
 *
 * To run a query within a React component, call `useSearchCustomersQuery` and pass it any options that fit your needs.
 * When your component renders, `useSearchCustomersQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useSearchCustomersQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useSearchCustomersQuery(baseOptions: Apollo.QueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
      }
export function useSearchCustomersLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<SearchCustomersQuery, SearchCustomersQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<SearchCustomersQuery, SearchCustomersQueryVariables>(SearchCustomersDocument, options);
        }
export type SearchCustomersQueryHookResult = ReturnType<typeof useSearchCustomersQuery>;
export type SearchCustomersLazyQueryHookResult = ReturnType<typeof useSearchCustomersLazyQuery>;
export type SearchCustomersQueryResult = Apollo.QueryResult<SearchCustomersQuery, SearchCustomersQueryVariables>;
export const DashboardStatsDocument = gql`
    query DashboardStats($input: DashboardStatsInput!) {
  dashboardStats(input: $input) {
    kpis {
      totalBookings
      totalRevenue
      activeCustomers
      cancellationRate
      bookingsChange
      revenueChange
      customersChange
      cancellationRateChange
    }
    trends {
      revenueTrend {
        date
        value
      }
      bookingsTrend {
        date
        value
      }
    }
    topLists {
      topServices {
        serviceId
        serviceName
        bookingsCount
        totalRevenue
      }
      topEmployees {
        employeeId
        employeeName
        bookingsCount
        totalRevenue
        occupancyRate
      }
    }
    monthlyOccupancy {
      days {
        date
        occupancyRate
        occupiedHours
        availableHours
      }
    }
  }
}
    `;

/**
 * __useDashboardStatsQuery__
 *
 * To run a query within a React component, call `useDashboardStatsQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardStatsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardStatsQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDashboardStatsQuery(baseOptions: Apollo.QueryHookOptions<DashboardStatsQuery, DashboardStatsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardStatsQuery, DashboardStatsQueryVariables>(DashboardStatsDocument, options);
      }
export function useDashboardStatsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardStatsQuery, DashboardStatsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardStatsQuery, DashboardStatsQueryVariables>(DashboardStatsDocument, options);
        }
export type DashboardStatsQueryHookResult = ReturnType<typeof useDashboardStatsQuery>;
export type DashboardStatsLazyQueryHookResult = ReturnType<typeof useDashboardStatsLazyQuery>;
export type DashboardStatsQueryResult = Apollo.QueryResult<DashboardStatsQuery, DashboardStatsQueryVariables>;
export const EmployeeDocument = gql`
    query Employee($employeeId: UUID!) {
  employee(id: $employeeId) {
    ...EmployeeDetails
    id
    position
    services {
      id
      name
      amount
    }
    tags {
      id
      name
      position
    }
  }
}
    ${EmployeeDetailsFragmentDoc}`;

/**
 * __useEmployeeQuery__
 *
 * To run a query within a React component, call `useEmployeeQuery` and pass it any options that fit your needs.
 * When your component renders, `useEmployeeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useEmployeeQuery({
 *   variables: {
 *      employeeId: // value for 'employeeId'
 *   },
 * });
 */
export function useEmployeeQuery(baseOptions: Apollo.QueryHookOptions<EmployeeQuery, EmployeeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, options);
      }
export function useEmployeeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<EmployeeQuery, EmployeeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<EmployeeQuery, EmployeeQueryVariables>(EmployeeDocument, options);
        }
export type EmployeeQueryHookResult = ReturnType<typeof useEmployeeQuery>;
export type EmployeeLazyQueryHookResult = ReturnType<typeof useEmployeeLazyQuery>;
export type EmployeeQueryResult = Apollo.QueryResult<EmployeeQuery, EmployeeQueryVariables>;
export const UpdateEmployeeDocument = gql`
    mutation UpdateEmployee($input: UpdateEmployeeInput!, $employeesInput: OrganizationEmployeesInput) {
  updateEmployee(input: $input) {
    id
    position
    ...EmployeeDetails
    services {
      id
      name
      amount
    }
    organization {
      id
      managementEmployees(input: $employeesInput) {
        id
        position
      }
    }
  }
}
    ${EmployeeDetailsFragmentDoc}`;
export type UpdateEmployeeMutationFn = Apollo.MutationFunction<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;

/**
 * __useUpdateEmployeeMutation__
 *
 * To run a mutation, you first call `useUpdateEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateEmployeeMutation, { data, loading, error }] = useUpdateEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      employeesInput: // value for 'employeesInput'
 *   },
 * });
 */
export function useUpdateEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>(UpdateEmployeeDocument, options);
      }
export type UpdateEmployeeMutationHookResult = ReturnType<typeof useUpdateEmployeeMutation>;
export type UpdateEmployeeMutationResult = Apollo.MutationResult<UpdateEmployeeMutation>;
export type UpdateEmployeeMutationOptions = Apollo.BaseMutationOptions<UpdateEmployeeMutation, UpdateEmployeeMutationVariables>;
export const AddEmployeeDocument = gql`
    mutation AddEmployee($input: AddEmployeeInput!, $employeesInput: OrganizationEmployeesInput) {
  addEmployee(input: $input) {
    id
    services {
      id
      name
      amount
    }
    managementEmployees(input: $employeesInput) {
      position
      ...EmployeeDetails
    }
  }
}
    ${EmployeeDetailsFragmentDoc}`;
export type AddEmployeeMutationFn = Apollo.MutationFunction<AddEmployeeMutation, AddEmployeeMutationVariables>;

/**
 * __useAddEmployeeMutation__
 *
 * To run a mutation, you first call `useAddEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addEmployeeMutation, { data, loading, error }] = useAddEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      employeesInput: // value for 'employeesInput'
 *   },
 * });
 */
export function useAddEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<AddEmployeeMutation, AddEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddEmployeeMutation, AddEmployeeMutationVariables>(AddEmployeeDocument, options);
      }
export type AddEmployeeMutationHookResult = ReturnType<typeof useAddEmployeeMutation>;
export type AddEmployeeMutationResult = Apollo.MutationResult<AddEmployeeMutation>;
export type AddEmployeeMutationOptions = Apollo.BaseMutationOptions<AddEmployeeMutation, AddEmployeeMutationVariables>;
export const DeleteEmployeeDocument = gql`
    mutation DeleteEmployee($input: DeleteEmployeeInput!, $employeesInput: OrganizationEmployeesInput) {
  deleteEmployee(input: $input) {
    id
    managementEmployees(input: $employeesInput) {
      ...EmployeeDetails
      position
    }
  }
}
    ${EmployeeDetailsFragmentDoc}`;
export type DeleteEmployeeMutationFn = Apollo.MutationFunction<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;

/**
 * __useDeleteEmployeeMutation__
 *
 * To run a mutation, you first call `useDeleteEmployeeMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteEmployeeMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteEmployeeMutation, { data, loading, error }] = useDeleteEmployeeMutation({
 *   variables: {
 *      input: // value for 'input'
 *      employeesInput: // value for 'employeesInput'
 *   },
 * });
 */
export function useDeleteEmployeeMutation(baseOptions?: Apollo.MutationHookOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>(DeleteEmployeeDocument, options);
      }
export type DeleteEmployeeMutationHookResult = ReturnType<typeof useDeleteEmployeeMutation>;
export type DeleteEmployeeMutationResult = Apollo.MutationResult<DeleteEmployeeMutation>;
export type DeleteEmployeeMutationOptions = Apollo.BaseMutationOptions<DeleteEmployeeMutation, DeleteEmployeeMutationVariables>;
export const ExtraPackagesDocument = gql`
    query ExtraPackages($organizationId: UUID) {
  organization(id: $organizationId) {
    id
    activeExtraPackages
  }
}
    `;

/**
 * __useExtraPackagesQuery__
 *
 * To run a query within a React component, call `useExtraPackagesQuery` and pass it any options that fit your needs.
 * When your component renders, `useExtraPackagesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useExtraPackagesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useExtraPackagesQuery(baseOptions?: Apollo.QueryHookOptions<ExtraPackagesQuery, ExtraPackagesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ExtraPackagesQuery, ExtraPackagesQueryVariables>(ExtraPackagesDocument, options);
      }
export function useExtraPackagesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ExtraPackagesQuery, ExtraPackagesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ExtraPackagesQuery, ExtraPackagesQueryVariables>(ExtraPackagesDocument, options);
        }
export type ExtraPackagesQueryHookResult = ReturnType<typeof useExtraPackagesQuery>;
export type ExtraPackagesLazyQueryHookResult = ReturnType<typeof useExtraPackagesLazyQuery>;
export type ExtraPackagesQueryResult = Apollo.QueryResult<ExtraPackagesQuery, ExtraPackagesQueryVariables>;
export const MeDocument = gql`
    query Me {
  me {
    id
    profilePictureAttachment {
      id
      publicUrl
    }
    name
    slug
    email
    ico
    email
    city
    street
    activeExtraPackages
    defaultLanguage
    supportedLanguages
  }
}
    `;

/**
 * __useMeQuery__
 *
 * To run a query within a React component, call `useMeQuery` and pass it any options that fit your needs.
 * When your component renders, `useMeQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useMeQuery({
 *   variables: {
 *   },
 * });
 */
export function useMeQuery(baseOptions?: Apollo.QueryHookOptions<MeQuery, MeQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<MeQuery, MeQueryVariables>(MeDocument, options);
      }
export function useMeLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<MeQuery, MeQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<MeQuery, MeQueryVariables>(MeDocument, options);
        }
export type MeQueryHookResult = ReturnType<typeof useMeQuery>;
export type MeLazyQueryHookResult = ReturnType<typeof useMeLazyQuery>;
export type MeQueryResult = Apollo.QueryResult<MeQuery, MeQueryVariables>;
export const SendResetPasswordEmailDocument = gql`
    mutation SendResetPasswordEmail($email: String!, $recaptchaToken: String!) {
  sendResetPasswordEmail(email: $email, recaptchaToken: $recaptchaToken)
}
    `;
export type SendResetPasswordEmailMutationFn = Apollo.MutationFunction<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;

/**
 * __useSendResetPasswordEmailMutation__
 *
 * To run a mutation, you first call `useSendResetPasswordEmailMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useSendResetPasswordEmailMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [sendResetPasswordEmailMutation, { data, loading, error }] = useSendResetPasswordEmailMutation({
 *   variables: {
 *      email: // value for 'email'
 *      recaptchaToken: // value for 'recaptchaToken'
 *   },
 * });
 */
export function useSendResetPasswordEmailMutation(baseOptions?: Apollo.MutationHookOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>(SendResetPasswordEmailDocument, options);
      }
export type SendResetPasswordEmailMutationHookResult = ReturnType<typeof useSendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationResult = Apollo.MutationResult<SendResetPasswordEmailMutation>;
export type SendResetPasswordEmailMutationOptions = Apollo.BaseMutationOptions<SendResetPasswordEmailMutation, SendResetPasswordEmailMutationVariables>;
export const ResetPasswordDocument = gql`
    mutation ResetPassword($input: ResetPasswordInput!) {
  resetPassword(input: $input)
}
    `;
export type ResetPasswordMutationFn = Apollo.MutationFunction<ResetPasswordMutation, ResetPasswordMutationVariables>;

/**
 * __useResetPasswordMutation__
 *
 * To run a mutation, you first call `useResetPasswordMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useResetPasswordMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [resetPasswordMutation, { data, loading, error }] = useResetPasswordMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useResetPasswordMutation(baseOptions?: Apollo.MutationHookOptions<ResetPasswordMutation, ResetPasswordMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ResetPasswordMutation, ResetPasswordMutationVariables>(ResetPasswordDocument, options);
      }
export type ResetPasswordMutationHookResult = ReturnType<typeof useResetPasswordMutation>;
export type ResetPasswordMutationResult = Apollo.MutationResult<ResetPasswordMutation>;
export type ResetPasswordMutationOptions = Apollo.BaseMutationOptions<ResetPasswordMutation, ResetPasswordMutationVariables>;
export const CustomerNoShowHistoryByEmailDocument = gql`
    query CustomerNoShowHistoryByEmail($input: CustomerNoShowHistoryInput!) {
  customerNoShowHistoryByEmail(input: $input) {
    count
    noShowCount
    lateCancellationCount
    windowMonths
  }
}
    `;

/**
 * __useCustomerNoShowHistoryByEmailQuery__
 *
 * To run a query within a React component, call `useCustomerNoShowHistoryByEmailQuery` and pass it any options that fit your needs.
 * When your component renders, `useCustomerNoShowHistoryByEmailQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useCustomerNoShowHistoryByEmailQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useCustomerNoShowHistoryByEmailQuery(baseOptions: Apollo.QueryHookOptions<CustomerNoShowHistoryByEmailQuery, CustomerNoShowHistoryByEmailQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<CustomerNoShowHistoryByEmailQuery, CustomerNoShowHistoryByEmailQueryVariables>(CustomerNoShowHistoryByEmailDocument, options);
      }
export function useCustomerNoShowHistoryByEmailLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<CustomerNoShowHistoryByEmailQuery, CustomerNoShowHistoryByEmailQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<CustomerNoShowHistoryByEmailQuery, CustomerNoShowHistoryByEmailQueryVariables>(CustomerNoShowHistoryByEmailDocument, options);
        }
export type CustomerNoShowHistoryByEmailQueryHookResult = ReturnType<typeof useCustomerNoShowHistoryByEmailQuery>;
export type CustomerNoShowHistoryByEmailLazyQueryHookResult = ReturnType<typeof useCustomerNoShowHistoryByEmailLazyQuery>;
export type CustomerNoShowHistoryByEmailQueryResult = Apollo.QueryResult<CustomerNoShowHistoryByEmailQuery, CustomerNoShowHistoryByEmailQueryVariables>;
export const NoShowListDocument = gql`
    query NoShowList($input: NoShowListInput!) {
  noShowList(input: $input) {
    reservationId
    firstName
    lastName
    email
    phoneNumber
    serviceName
    serviceAmount
    date
    localStartTime
    startAtUtc
    noShowType
    noShowAtUtc
    markedBy
  }
}
    `;

/**
 * __useNoShowListQuery__
 *
 * To run a query within a React component, call `useNoShowListQuery` and pass it any options that fit your needs.
 * When your component renders, `useNoShowListQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useNoShowListQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useNoShowListQuery(baseOptions: Apollo.QueryHookOptions<NoShowListQuery, NoShowListQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<NoShowListQuery, NoShowListQueryVariables>(NoShowListDocument, options);
      }
export function useNoShowListLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<NoShowListQuery, NoShowListQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<NoShowListQuery, NoShowListQueryVariables>(NoShowListDocument, options);
        }
export type NoShowListQueryHookResult = ReturnType<typeof useNoShowListQuery>;
export type NoShowListLazyQueryHookResult = ReturnType<typeof useNoShowListLazyQuery>;
export type NoShowListQueryResult = Apollo.QueryResult<NoShowListQuery, NoShowListQueryVariables>;
export const MarkServiceReservationNoShowDocument = gql`
    mutation MarkServiceReservationNoShow($input: MarkNoShowInput!) {
  markServiceReservationNoShow(input: $input) {
    id
    noShowAtUtc
    noShowType
  }
}
    `;
export type MarkServiceReservationNoShowMutationFn = Apollo.MutationFunction<MarkServiceReservationNoShowMutation, MarkServiceReservationNoShowMutationVariables>;

/**
 * __useMarkServiceReservationNoShowMutation__
 *
 * To run a mutation, you first call `useMarkServiceReservationNoShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useMarkServiceReservationNoShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [markServiceReservationNoShowMutation, { data, loading, error }] = useMarkServiceReservationNoShowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useMarkServiceReservationNoShowMutation(baseOptions?: Apollo.MutationHookOptions<MarkServiceReservationNoShowMutation, MarkServiceReservationNoShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<MarkServiceReservationNoShowMutation, MarkServiceReservationNoShowMutationVariables>(MarkServiceReservationNoShowDocument, options);
      }
export type MarkServiceReservationNoShowMutationHookResult = ReturnType<typeof useMarkServiceReservationNoShowMutation>;
export type MarkServiceReservationNoShowMutationResult = Apollo.MutationResult<MarkServiceReservationNoShowMutation>;
export type MarkServiceReservationNoShowMutationOptions = Apollo.BaseMutationOptions<MarkServiceReservationNoShowMutation, MarkServiceReservationNoShowMutationVariables>;
export const UnmarkServiceReservationNoShowDocument = gql`
    mutation UnmarkServiceReservationNoShow($input: UnmarkNoShowInput!) {
  unmarkServiceReservationNoShow(input: $input) {
    id
    noShowAtUtc
    noShowType
  }
}
    `;
export type UnmarkServiceReservationNoShowMutationFn = Apollo.MutationFunction<UnmarkServiceReservationNoShowMutation, UnmarkServiceReservationNoShowMutationVariables>;

/**
 * __useUnmarkServiceReservationNoShowMutation__
 *
 * To run a mutation, you first call `useUnmarkServiceReservationNoShowMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUnmarkServiceReservationNoShowMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [unmarkServiceReservationNoShowMutation, { data, loading, error }] = useUnmarkServiceReservationNoShowMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUnmarkServiceReservationNoShowMutation(baseOptions?: Apollo.MutationHookOptions<UnmarkServiceReservationNoShowMutation, UnmarkServiceReservationNoShowMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UnmarkServiceReservationNoShowMutation, UnmarkServiceReservationNoShowMutationVariables>(UnmarkServiceReservationNoShowDocument, options);
      }
export type UnmarkServiceReservationNoShowMutationHookResult = ReturnType<typeof useUnmarkServiceReservationNoShowMutation>;
export type UnmarkServiceReservationNoShowMutationResult = Apollo.MutationResult<UnmarkServiceReservationNoShowMutation>;
export type UnmarkServiceReservationNoShowMutationOptions = Apollo.BaseMutationOptions<UnmarkServiceReservationNoShowMutation, UnmarkServiceReservationNoShowMutationVariables>;
export const OrganizationBySlugDocument = gql`
    query OrganizationBySlug($organizationSlug: String) {
  organization(slug: $organizationSlug) {
    id
  }
}
    `;

/**
 * __useOrganizationBySlugQuery__
 *
 * To run a query within a React component, call `useOrganizationBySlugQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationBySlugQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationBySlugQuery({
 *   variables: {
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useOrganizationBySlugQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationBySlugQuery, OrganizationBySlugQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationBySlugQuery, OrganizationBySlugQueryVariables>(OrganizationBySlugDocument, options);
      }
export function useOrganizationBySlugLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationBySlugQuery, OrganizationBySlugQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationBySlugQuery, OrganizationBySlugQueryVariables>(OrganizationBySlugDocument, options);
        }
export type OrganizationBySlugQueryHookResult = ReturnType<typeof useOrganizationBySlugQuery>;
export type OrganizationBySlugLazyQueryHookResult = ReturnType<typeof useOrganizationBySlugLazyQuery>;
export type OrganizationBySlugQueryResult = Apollo.QueryResult<OrganizationBySlugQuery, OrganizationBySlugQueryVariables>;
export const OrganizationStaticDataDocument = gql`
    query OrganizationStaticData($organizationId: UUID, $organizationSlug: String) {
  organization(id: $organizationId, slug: $organizationSlug) {
    id
    slug
    name
    city
    street
    note
  }
}
    `;

/**
 * __useOrganizationStaticDataQuery__
 *
 * To run a query within a React component, call `useOrganizationStaticDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationStaticDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationStaticDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useOrganizationStaticDataQuery(baseOptions?: Apollo.QueryHookOptions<OrganizationStaticDataQuery, OrganizationStaticDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationStaticDataQuery, OrganizationStaticDataQueryVariables>(OrganizationStaticDataDocument, options);
      }
export function useOrganizationStaticDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationStaticDataQuery, OrganizationStaticDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationStaticDataQuery, OrganizationStaticDataQueryVariables>(OrganizationStaticDataDocument, options);
        }
export type OrganizationStaticDataQueryHookResult = ReturnType<typeof useOrganizationStaticDataQuery>;
export type OrganizationStaticDataLazyQueryHookResult = ReturnType<typeof useOrganizationStaticDataLazyQuery>;
export type OrganizationStaticDataQueryResult = Apollo.QueryResult<OrganizationStaticDataQuery, OrganizationStaticDataQueryVariables>;
export const GetAppointmentOrganizationDataDocument = gql`
    query GetAppointmentOrganizationData($organizationId: UUID, $organizationSlug: String) {
  organization(id: $organizationId, slug: $organizationSlug) {
    id
    name
    isOfferingAnyQueue
    isOfferingAnyBookable
  }
}
    `;

/**
 * __useGetAppointmentOrganizationDataQuery__
 *
 * To run a query within a React component, call `useGetAppointmentOrganizationDataQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetAppointmentOrganizationDataQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetAppointmentOrganizationDataQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      organizationSlug: // value for 'organizationSlug'
 *   },
 * });
 */
export function useGetAppointmentOrganizationDataQuery(baseOptions?: Apollo.QueryHookOptions<GetAppointmentOrganizationDataQuery, GetAppointmentOrganizationDataQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<GetAppointmentOrganizationDataQuery, GetAppointmentOrganizationDataQueryVariables>(GetAppointmentOrganizationDataDocument, options);
      }
export function useGetAppointmentOrganizationDataLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<GetAppointmentOrganizationDataQuery, GetAppointmentOrganizationDataQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<GetAppointmentOrganizationDataQuery, GetAppointmentOrganizationDataQueryVariables>(GetAppointmentOrganizationDataDocument, options);
        }
export type GetAppointmentOrganizationDataQueryHookResult = ReturnType<typeof useGetAppointmentOrganizationDataQuery>;
export type GetAppointmentOrganizationDataLazyQueryHookResult = ReturnType<typeof useGetAppointmentOrganizationDataLazyQuery>;
export type GetAppointmentOrganizationDataQueryResult = Apollo.QueryResult<GetAppointmentOrganizationDataQuery, GetAppointmentOrganizationDataQueryVariables>;
export const DashboardOrganizationGeneralInformationDocument = gql`
    query DashboardOrganizationGeneralInformation($organizationId: UUID!) {
  organization(id: $organizationId) {
    id
    daysInFutureAllowedToBook
    defaultLanguage
    supportedLanguages
  }
}
    `;

/**
 * __useDashboardOrganizationGeneralInformationQuery__
 *
 * To run a query within a React component, call `useDashboardOrganizationGeneralInformationQuery` and pass it any options that fit your needs.
 * When your component renders, `useDashboardOrganizationGeneralInformationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useDashboardOrganizationGeneralInformationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useDashboardOrganizationGeneralInformationQuery(baseOptions: Apollo.QueryHookOptions<DashboardOrganizationGeneralInformationQuery, DashboardOrganizationGeneralInformationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<DashboardOrganizationGeneralInformationQuery, DashboardOrganizationGeneralInformationQueryVariables>(DashboardOrganizationGeneralInformationDocument, options);
      }
export function useDashboardOrganizationGeneralInformationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<DashboardOrganizationGeneralInformationQuery, DashboardOrganizationGeneralInformationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<DashboardOrganizationGeneralInformationQuery, DashboardOrganizationGeneralInformationQueryVariables>(DashboardOrganizationGeneralInformationDocument, options);
        }
export type DashboardOrganizationGeneralInformationQueryHookResult = ReturnType<typeof useDashboardOrganizationGeneralInformationQuery>;
export type DashboardOrganizationGeneralInformationLazyQueryHookResult = ReturnType<typeof useDashboardOrganizationGeneralInformationLazyQuery>;
export type DashboardOrganizationGeneralInformationQueryResult = Apollo.QueryResult<DashboardOrganizationGeneralInformationQuery, DashboardOrganizationGeneralInformationQueryVariables>;
export const OrganizationDocument = gql`
    query Organization($organizationId: UUID!, $employeesInput: OrganizationEmployeesInput) {
  organization(id: $organizationId) {
    id
    slug
    name
    city
    street
    email
    employees(input: $employeesInput) {
      id
      description
      profilePictureAttachment {
        id
        publicUrl
      }
      name
      status
    }
  }
}
    `;

/**
 * __useOrganizationQuery__
 *
 * To run a query within a React component, call `useOrganizationQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      employeesInput: // value for 'employeesInput'
 *   },
 * });
 */
export function useOrganizationQuery(baseOptions: Apollo.QueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
      }
export function useOrganizationLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationQuery, OrganizationQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationQuery, OrganizationQueryVariables>(OrganizationDocument, options);
        }
export type OrganizationQueryHookResult = ReturnType<typeof useOrganizationQuery>;
export type OrganizationLazyQueryHookResult = ReturnType<typeof useOrganizationLazyQuery>;
export type OrganizationQueryResult = Apollo.QueryResult<OrganizationQuery, OrganizationQueryVariables>;
export const OrganizationEmployeesDocument = gql`
    query OrganizationEmployees($organizationId: UUID!, $input: OrganizationEmployeesInput) {
  organization(id: $organizationId) {
    id
    managementEmployees(input: $input) {
      id
      email
      name
      description
      status
      position
      profilePictureAttachment {
        id
        publicUrl
      }
      organization {
        id
        name
      }
    }
  }
}
    `;

/**
 * __useOrganizationEmployeesQuery__
 *
 * To run a query within a React component, call `useOrganizationEmployeesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationEmployeesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationEmployeesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationEmployeesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>(OrganizationEmployeesDocument, options);
      }
export function useOrganizationEmployeesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>(OrganizationEmployeesDocument, options);
        }
export type OrganizationEmployeesQueryHookResult = ReturnType<typeof useOrganizationEmployeesQuery>;
export type OrganizationEmployeesLazyQueryHookResult = ReturnType<typeof useOrganizationEmployeesLazyQuery>;
export type OrganizationEmployeesQueryResult = Apollo.QueryResult<OrganizationEmployeesQuery, OrganizationEmployeesQueryVariables>;
export const OrganizationServicesDocument = gql`
    query OrganizationServices($organizationId: UUID!) {
  organization(id: $organizationId) {
    id
    services {
      id
      name
      description
      amount
      attachment {
        id
        publicUrl
      }
    }
  }
}
    `;

/**
 * __useOrganizationServicesQuery__
 *
 * To run a query within a React component, call `useOrganizationServicesQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationServicesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationServicesQuery({
 *   variables: {
 *      organizationId: // value for 'organizationId'
 *   },
 * });
 */
export function useOrganizationServicesQuery(baseOptions: Apollo.QueryHookOptions<OrganizationServicesQuery, OrganizationServicesQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationServicesQuery, OrganizationServicesQueryVariables>(OrganizationServicesDocument, options);
      }
export function useOrganizationServicesLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationServicesQuery, OrganizationServicesQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationServicesQuery, OrganizationServicesQueryVariables>(OrganizationServicesDocument, options);
        }
export type OrganizationServicesQueryHookResult = ReturnType<typeof useOrganizationServicesQuery>;
export type OrganizationServicesLazyQueryHookResult = ReturnType<typeof useOrganizationServicesLazyQuery>;
export type OrganizationServicesQueryResult = Apollo.QueryResult<OrganizationServicesQuery, OrganizationServicesQueryVariables>;
export const UpdateOrganizationDocument = gql`
    mutation UpdateOrganization($input: UpdateOrganizationInput!) {
  updateOrganization(input: $input) {
    id
    daysInFutureAllowedToBook
    defaultLanguage
    supportedLanguages
  }
}
    `;
export type UpdateOrganizationMutationFn = Apollo.MutationFunction<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;

/**
 * __useUpdateOrganizationMutation__
 *
 * To run a mutation, you first call `useUpdateOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateOrganizationMutation, { data, loading, error }] = useUpdateOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>(UpdateOrganizationDocument, options);
      }
export type UpdateOrganizationMutationHookResult = ReturnType<typeof useUpdateOrganizationMutation>;
export type UpdateOrganizationMutationResult = Apollo.MutationResult<UpdateOrganizationMutation>;
export type UpdateOrganizationMutationOptions = Apollo.BaseMutationOptions<UpdateOrganizationMutation, UpdateOrganizationMutationVariables>;
export const OrganizationOnboardingDocument = gql`
    query OrganizationOnboarding($input: OrganizationOnboardingInput!) {
  organizationOnboarding(input: $input) {
    id
    name
    createdAtUtc {
      isoFormat
    }
  }
}
    `;

/**
 * __useOrganizationOnboardingQuery__
 *
 * To run a query within a React component, call `useOrganizationOnboardingQuery` and pass it any options that fit your needs.
 * When your component renders, `useOrganizationOnboardingQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useOrganizationOnboardingQuery({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOrganizationOnboardingQuery(baseOptions: Apollo.QueryHookOptions<OrganizationOnboardingQuery, OrganizationOnboardingQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<OrganizationOnboardingQuery, OrganizationOnboardingQueryVariables>(OrganizationOnboardingDocument, options);
      }
export function useOrganizationOnboardingLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<OrganizationOnboardingQuery, OrganizationOnboardingQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<OrganizationOnboardingQuery, OrganizationOnboardingQueryVariables>(OrganizationOnboardingDocument, options);
        }
export type OrganizationOnboardingQueryHookResult = ReturnType<typeof useOrganizationOnboardingQuery>;
export type OrganizationOnboardingLazyQueryHookResult = ReturnType<typeof useOrganizationOnboardingLazyQuery>;
export type OrganizationOnboardingQueryResult = Apollo.QueryResult<OrganizationOnboardingQuery, OrganizationOnboardingQueryVariables>;
export const OnboardOrganizationDocument = gql`
    mutation OnboardOrganization($input: OnboardOrganizationInput!) {
  onboardOrganization(input: $input) {
    id
  }
}
    `;
export type OnboardOrganizationMutationFn = Apollo.MutationFunction<OnboardOrganizationMutation, OnboardOrganizationMutationVariables>;

/**
 * __useOnboardOrganizationMutation__
 *
 * To run a mutation, you first call `useOnboardOrganizationMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useOnboardOrganizationMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [onboardOrganizationMutation, { data, loading, error }] = useOnboardOrganizationMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useOnboardOrganizationMutation(baseOptions?: Apollo.MutationHookOptions<OnboardOrganizationMutation, OnboardOrganizationMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<OnboardOrganizationMutation, OnboardOrganizationMutationVariables>(OnboardOrganizationDocument, options);
      }
export type OnboardOrganizationMutationHookResult = ReturnType<typeof useOnboardOrganizationMutation>;
export type OnboardOrganizationMutationResult = Apollo.MutationResult<OnboardOrganizationMutation>;
export type OnboardOrganizationMutationOptions = Apollo.BaseMutationOptions<OnboardOrganizationMutation, OnboardOrganizationMutationVariables>;
export const ServiceDocument = gql`
    query Service($serviceId: UUID!) {
  service(id: $serviceId) {
    id
    name
    description
    nameTranslations
    descriptionTranslations
    amount
    duration
    position
    attachment {
      id
      publicUrl
    }
    tags {
      id
      name
      position
    }
  }
}
    `;

/**
 * __useServiceQuery__
 *
 * To run a query within a React component, call `useServiceQuery` and pass it any options that fit your needs.
 * When your component renders, `useServiceQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useServiceQuery({
 *   variables: {
 *      serviceId: // value for 'serviceId'
 *   },
 * });
 */
export function useServiceQuery(baseOptions: Apollo.QueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, options);
      }
export function useServiceLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<ServiceQuery, ServiceQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<ServiceQuery, ServiceQueryVariables>(ServiceDocument, options);
        }
export type ServiceQueryHookResult = ReturnType<typeof useServiceQuery>;
export type ServiceLazyQueryHookResult = ReturnType<typeof useServiceLazyQuery>;
export type ServiceQueryResult = Apollo.QueryResult<ServiceQuery, ServiceQueryVariables>;
export const AddServiceDocument = gql`
    mutation AddService($input: AddServiceInput!) {
  addService(input: $input) {
    id
    services {
      id
      name
      description
      amount
      duration
      position
      attachment {
        id
        publicUrl
      }
    }
  }
}
    `;
export type AddServiceMutationFn = Apollo.MutationFunction<AddServiceMutation, AddServiceMutationVariables>;

/**
 * __useAddServiceMutation__
 *
 * To run a mutation, you first call `useAddServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addServiceMutation, { data, loading, error }] = useAddServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddServiceMutation(baseOptions?: Apollo.MutationHookOptions<AddServiceMutation, AddServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddServiceMutation, AddServiceMutationVariables>(AddServiceDocument, options);
      }
export type AddServiceMutationHookResult = ReturnType<typeof useAddServiceMutation>;
export type AddServiceMutationResult = Apollo.MutationResult<AddServiceMutation>;
export type AddServiceMutationOptions = Apollo.BaseMutationOptions<AddServiceMutation, AddServiceMutationVariables>;
export const UpdateServiceDocument = gql`
    mutation UpdateService($input: UpdateServiceInput!) {
  updateService(input: $input) {
    id
    services {
      id
      name
      description
      amount
      duration
      position
      attachment {
        id
        publicUrl
      }
    }
  }
}
    `;
export type UpdateServiceMutationFn = Apollo.MutationFunction<UpdateServiceMutation, UpdateServiceMutationVariables>;

/**
 * __useUpdateServiceMutation__
 *
 * To run a mutation, you first call `useUpdateServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateServiceMutation, { data, loading, error }] = useUpdateServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateServiceMutation(baseOptions?: Apollo.MutationHookOptions<UpdateServiceMutation, UpdateServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateServiceMutation, UpdateServiceMutationVariables>(UpdateServiceDocument, options);
      }
export type UpdateServiceMutationHookResult = ReturnType<typeof useUpdateServiceMutation>;
export type UpdateServiceMutationResult = Apollo.MutationResult<UpdateServiceMutation>;
export type UpdateServiceMutationOptions = Apollo.BaseMutationOptions<UpdateServiceMutation, UpdateServiceMutationVariables>;
export const DeleteServiceDocument = gql`
    mutation DeleteService($input: DeleteServiceInput!) {
  deleteService(input: $input) {
    id
    services {
      id
      name
      description
      amount
      duration
      position
      attachment {
        id
        publicUrl
      }
    }
  }
}
    `;
export type DeleteServiceMutationFn = Apollo.MutationFunction<DeleteServiceMutation, DeleteServiceMutationVariables>;

/**
 * __useDeleteServiceMutation__
 *
 * To run a mutation, you first call `useDeleteServiceMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteServiceMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteServiceMutation, { data, loading, error }] = useDeleteServiceMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteServiceMutation(baseOptions?: Apollo.MutationHookOptions<DeleteServiceMutation, DeleteServiceMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteServiceMutation, DeleteServiceMutationVariables>(DeleteServiceDocument, options);
      }
export type DeleteServiceMutationHookResult = ReturnType<typeof useDeleteServiceMutation>;
export type DeleteServiceMutationResult = Apollo.MutationResult<DeleteServiceMutation>;
export type DeleteServiceMutationOptions = Apollo.BaseMutationOptions<DeleteServiceMutation, DeleteServiceMutationVariables>;
export const TagsDocument = gql`
    query Tags {
  tags {
    id
    name
    nameTranslations
    position
  }
}
    `;

/**
 * __useTagsQuery__
 *
 * To run a query within a React component, call `useTagsQuery` and pass it any options that fit your needs.
 * When your component renders, `useTagsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useTagsQuery({
 *   variables: {
 *   },
 * });
 */
export function useTagsQuery(baseOptions?: Apollo.QueryHookOptions<TagsQuery, TagsQueryVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
      }
export function useTagsLazyQuery(baseOptions?: Apollo.LazyQueryHookOptions<TagsQuery, TagsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return Apollo.useLazyQuery<TagsQuery, TagsQueryVariables>(TagsDocument, options);
        }
export type TagsQueryHookResult = ReturnType<typeof useTagsQuery>;
export type TagsLazyQueryHookResult = ReturnType<typeof useTagsLazyQuery>;
export type TagsQueryResult = Apollo.QueryResult<TagsQuery, TagsQueryVariables>;
export const AddTagDocument = gql`
    mutation AddTag($input: AddTagInput!) {
  addTag(input: $input) {
    id
    services {
      id
      name
      tags {
        id
        name
        position
      }
    }
  }
}
    `;
export type AddTagMutationFn = Apollo.MutationFunction<AddTagMutation, AddTagMutationVariables>;

/**
 * __useAddTagMutation__
 *
 * To run a mutation, you first call `useAddTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useAddTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [addTagMutation, { data, loading, error }] = useAddTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useAddTagMutation(baseOptions?: Apollo.MutationHookOptions<AddTagMutation, AddTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<AddTagMutation, AddTagMutationVariables>(AddTagDocument, options);
      }
export type AddTagMutationHookResult = ReturnType<typeof useAddTagMutation>;
export type AddTagMutationResult = Apollo.MutationResult<AddTagMutation>;
export type AddTagMutationOptions = Apollo.BaseMutationOptions<AddTagMutation, AddTagMutationVariables>;
export const UpdateTagDocument = gql`
    mutation UpdateTag($input: UpdateTagInput!) {
  updateTag(input: $input) {
    id
    services {
      id
      name
      tags {
        id
        name
        position
      }
    }
  }
}
    `;
export type UpdateTagMutationFn = Apollo.MutationFunction<UpdateTagMutation, UpdateTagMutationVariables>;

/**
 * __useUpdateTagMutation__
 *
 * To run a mutation, you first call `useUpdateTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useUpdateTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [updateTagMutation, { data, loading, error }] = useUpdateTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useUpdateTagMutation(baseOptions?: Apollo.MutationHookOptions<UpdateTagMutation, UpdateTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<UpdateTagMutation, UpdateTagMutationVariables>(UpdateTagDocument, options);
      }
export type UpdateTagMutationHookResult = ReturnType<typeof useUpdateTagMutation>;
export type UpdateTagMutationResult = Apollo.MutationResult<UpdateTagMutation>;
export type UpdateTagMutationOptions = Apollo.BaseMutationOptions<UpdateTagMutation, UpdateTagMutationVariables>;
export const DeleteTagDocument = gql`
    mutation DeleteTag($input: DeleteTagInput!) {
  deleteTag(input: $input) {
    id
    services {
      id
      name
      tags {
        id
        name
        position
      }
    }
  }
}
    `;
export type DeleteTagMutationFn = Apollo.MutationFunction<DeleteTagMutation, DeleteTagMutationVariables>;

/**
 * __useDeleteTagMutation__
 *
 * To run a mutation, you first call `useDeleteTagMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeleteTagMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deleteTagMutation, { data, loading, error }] = useDeleteTagMutation({
 *   variables: {
 *      input: // value for 'input'
 *   },
 * });
 */
export function useDeleteTagMutation(baseOptions?: Apollo.MutationHookOptions<DeleteTagMutation, DeleteTagMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<DeleteTagMutation, DeleteTagMutationVariables>(DeleteTagDocument, options);
      }
export type DeleteTagMutationHookResult = ReturnType<typeof useDeleteTagMutation>;
export type DeleteTagMutationResult = Apollo.MutationResult<DeleteTagMutation>;
export type DeleteTagMutationOptions = Apollo.BaseMutationOptions<DeleteTagMutation, DeleteTagMutationVariables>;